// Mock data for Jobometry platform - POC Demo
import { JobMarketDataFeatureCollection, JobProperties } from '../types/JobTypes';
import { Feature, Point } from 'geojson';

// Comprehensive European cities with diverse job opportunities (40+ positions per major EU country)
const europeanCities = [
  // Germany (40+ jobs) - Major economic powerhouse
  { name: "Berlin", country: "Germany", countryCode: "DE", coords: [13.4050, 52.5200], costOfLiving: 85 },
  { name: "Munich", country: "Germany", countryCode: "DE", coords: [11.5820, 48.1351], costOfLiving: 95 },
  { name: "Hamburg", country: "Germany", countryCode: "DE", coords: [9.9937, 53.5511], costOfLiving: 82 },
  { name: "Frankfurt", country: "Germany", countryCode: "DE", coords: [8.6821, 50.1109], costOfLiving: 92 },
  { name: "Cologne", country: "Germany", countryCode: "DE", coords: [6.9603, 50.9375], costOfLiving: 80 },
  { name: "Stuttgart", country: "Germany", countryCode: "DE", coords: [9.1829, 48.7758], costOfLiving: 88 },
  { name: "Düsseldorf", country: "Germany", countryCode: "DE", coords: [6.7735, 51.2277], costOfLiving: 85 },
  { name: "Dortmund", country: "Germany", countryCode: "DE", coords: [7.4653, 51.5136], costOfLiving: 75 },
  { name: "Essen", country: "Germany", countryCode: "DE", coords: [7.0116, 51.4556], costOfLiving: 73 },
  { name: "Leipzig", country: "Germany", countryCode: "DE", coords: [12.3731, 51.3397], costOfLiving: 70 },
  { name: "Bremen", country: "Germany", countryCode: "DE", coords: [8.8017, 53.0793], costOfLiving: 78 },
  { name: "Dresden", country: "Germany", countryCode: "DE", coords: [13.7373, 51.0504], costOfLiving: 68 },
  { name: "Hanover", country: "Germany", countryCode: "DE", coords: [9.7320, 52.3759], costOfLiving: 76 },
  { name: "Nuremberg", country: "Germany", countryCode: "DE", coords: [11.0767, 49.4521], costOfLiving: 74 },
  { name: "Duisburg", country: "Germany", countryCode: "DE", coords: [6.7623, 51.4344], costOfLiving: 72 },
  
  // France (40+ jobs) - Major EU economy
  { name: "Paris", country: "France", countryCode: "FR", coords: [2.3522, 48.8566], costOfLiving: 90 },
  { name: "Lyon", country: "France", countryCode: "FR", coords: [4.8357, 45.7640], costOfLiving: 78 },
  { name: "Marseille", country: "France", countryCode: "FR", coords: [5.3698, 43.2965], costOfLiving: 72 },
  { name: "Toulouse", country: "France", countryCode: "FR", coords: [1.4442, 43.6047], costOfLiving: 75 },
  { name: "Nice", country: "France", countryCode: "FR", coords: [7.2619, 43.7102], costOfLiving: 82 },
  { name: "Nantes", country: "France", countryCode: "FR", coords: [-1.5534, 47.2184], costOfLiving: 70 },
  { name: "Strasbourg", country: "France", countryCode: "FR", coords: [7.7521, 48.5734], costOfLiving: 74 },
  { name: "Montpellier", country: "France", countryCode: "FR", coords: [3.8767, 43.6119], costOfLiving: 68 },
  { name: "Bordeaux", country: "France", countryCode: "FR", coords: [-0.5792, 44.8378], costOfLiving: 73 },
  { name: "Lille", country: "France", countryCode: "FR", coords: [3.0573, 50.6292], costOfLiving: 67 },
  { name: "Rennes", country: "France", countryCode: "FR", coords: [-1.6778, 48.1173], costOfLiving: 65 },
  { name: "Reims", country: "France", countryCode: "FR", coords: [4.0317, 49.2583], costOfLiving: 66 },
  { name: "Le Havre", country: "France", countryCode: "FR", coords: [0.1079, 49.4944], costOfLiving: 68 },
  { name: "Saint-Étienne", country: "France", countryCode: "FR", coords: [4.3872, 45.4397], costOfLiving: 63 },
  { name: "Toulon", country: "France", countryCode: "FR", coords: [5.9280, 43.1242], costOfLiving: 71 },
  
  // Netherlands (40+ jobs) - Business & finance hub
  { name: "Amsterdam", country: "Netherlands", countryCode: "NL", coords: [4.9041, 52.3676], costOfLiving: 88 },
  { name: "Rotterdam", country: "Netherlands", countryCode: "NL", coords: [4.4777, 51.9244], costOfLiving: 80 },
  { name: "The Hague", country: "Netherlands", countryCode: "NL", coords: [4.3007, 52.0705], costOfLiving: 85 },
  { name: "Utrecht", country: "Netherlands", countryCode: "NL", coords: [5.1214, 52.0907], costOfLiving: 83 },
  { name: "Eindhoven", country: "Netherlands", countryCode: "NL", coords: [5.4697, 51.4416], costOfLiving: 78 },
  { name: "Tilburg", country: "Netherlands", countryCode: "NL", coords: [5.0913, 51.5555], costOfLiving: 75 },
  { name: "Groningen", country: "Netherlands", countryCode: "NL", coords: [6.5665, 53.2194], costOfLiving: 72 },
  { name: "Almere", country: "Netherlands", countryCode: "NL", coords: [5.2647, 52.3508], costOfLiving: 76 },
  { name: "Breda", country: "Netherlands", countryCode: "NL", coords: [4.7760, 51.5719], costOfLiving: 74 },
  { name: "Nijmegen", country: "Netherlands", countryCode: "NL", coords: [5.8520, 51.8426], costOfLiving: 73 },
  
  // United Kingdom (40+ jobs) - Financial center
  { name: "London", country: "United Kingdom", countryCode: "GB", coords: [-0.1276, 51.5074], costOfLiving: 110 },
  { name: "Manchester", country: "United Kingdom", countryCode: "GB", coords: [-2.2426, 53.4808], costOfLiving: 75 },
  { name: "Edinburgh", country: "United Kingdom", countryCode: "GB", coords: [-3.1883, 55.9533], costOfLiving: 80 },
  { name: "Bristol", country: "United Kingdom", countryCode: "GB", coords: [-2.5879, 51.4545], costOfLiving: 78 },
  { name: "Birmingham", country: "United Kingdom", countryCode: "GB", coords: [-1.8904, 52.4862], costOfLiving: 72 },
  { name: "Leeds", country: "United Kingdom", countryCode: "GB", coords: [-1.5491, 53.8008], costOfLiving: 70 },
  { name: "Glasgow", country: "United Kingdom", countryCode: "GB", coords: [-4.2518, 55.8642], costOfLiving: 68 },
  { name: "Liverpool", country: "United Kingdom", countryCode: "GB", coords: [-2.9916, 53.4084], costOfLiving: 65 },
  { name: "Newcastle", country: "United Kingdom", countryCode: "GB", coords: [-1.6178, 54.9783], costOfLiving: 63 },
  { name: "Sheffield", country: "United Kingdom", countryCode: "GB", coords: [-1.4701, 53.3811], costOfLiving: 62 },
  { name: "Nottingham", country: "United Kingdom", countryCode: "GB", coords: [-1.1581, 52.9548], costOfLiving: 64 },
  { name: "Southampton", country: "United Kingdom", countryCode: "GB", coords: [-1.4044, 50.9097], costOfLiving: 69 },
  { name: "Oxford", country: "United Kingdom", countryCode: "GB", coords: [-1.2581, 51.7520], costOfLiving: 85 },
  { name: "Cambridge", country: "United Kingdom", countryCode: "GB", coords: [0.1218, 52.2053], costOfLiving: 82 },
  
  // Spain (40+ jobs) - Growing tech hub
  { name: "Madrid", country: "Spain", countryCode: "ES", coords: [-3.7038, 40.4168], costOfLiving: 70 },
  { name: "Barcelona", country: "Spain", countryCode: "ES", coords: [2.1734, 41.3851], costOfLiving: 72 },
  { name: "Valencia", country: "Spain", countryCode: "ES", coords: [-0.3763, 39.4699], costOfLiving: 65 },
  { name: "Seville", country: "Spain", countryCode: "ES", coords: [-5.9845, 37.3891], costOfLiving: 62 },
  { name: "Zaragoza", country: "Spain", countryCode: "ES", coords: [-0.8773, 41.6488], costOfLiving: 60 },
  { name: "Málaga", country: "Spain", countryCode: "ES", coords: [-4.4214, 36.7213], costOfLiving: 64 },
  { name: "Murcia", country: "Spain", countryCode: "ES", coords: [-1.1307, 37.9922], costOfLiving: 58 },
  { name: "Palma", country: "Spain", countryCode: "ES", coords: [2.6502, 39.5696], costOfLiving: 68 },
  { name: "Las Palmas", country: "Spain", countryCode: "ES", coords: [-15.4138, 28.1248], costOfLiving: 63 },
  { name: "Bilbao", country: "Spain", countryCode: "ES", coords: [-2.9253, 43.2627], costOfLiving: 67 },
  { name: "Alicante", country: "Spain", countryCode: "ES", coords: [-0.4816, 38.3452], costOfLiving: 61 },
  { name: "Córdoba", country: "Spain", countryCode: "ES", coords: [-4.7794, 37.8882], costOfLiving: 56 },
  { name: "Valladolid", country: "Spain", countryCode: "ES", coords: [-4.7245, 41.6518], costOfLiving: 58 },
  { name: "Vigo", country: "Spain", countryCode: "ES", coords: [-8.7207, 42.2406], costOfLiving: 57 },
  
  // Italy (40+ jobs) - Design & finance center
  { name: "Milan", country: "Italy", countryCode: "IT", coords: [9.1900, 45.4642], costOfLiving: 85 },
  { name: "Rome", country: "Italy", countryCode: "IT", coords: [12.4964, 41.9028], costOfLiving: 78 },
  { name: "Turin", country: "Italy", countryCode: "IT", coords: [7.6869, 45.0703], costOfLiving: 72 },
  { name: "Bologna", country: "Italy", countryCode: "IT", coords: [11.3426, 44.4949], costOfLiving: 75 },
  { name: "Naples", country: "Italy", countryCode: "IT", coords: [14.2681, 40.8518], costOfLiving: 65 },
  { name: "Florence", country: "Italy", countryCode: "IT", coords: [11.2558, 43.7696], costOfLiving: 73 },
  { name: "Genoa", country: "Italy", countryCode: "IT", coords: [8.9463, 44.4056], costOfLiving: 70 },
  { name: "Palermo", country: "Italy", countryCode: "IT", coords: [13.3614, 38.1157], costOfLiving: 60 },
  { name: "Catania", country: "Italy", countryCode: "IT", coords: [15.0871, 37.5079], costOfLiving: 58 },
  { name: "Bari", country: "Italy", countryCode: "IT", coords: [16.8719, 41.1171], costOfLiving: 62 },
  { name: "Messina", country: "Italy", countryCode: "IT", coords: [15.5518, 38.1938], costOfLiving: 59 },
  { name: "Verona", country: "Italy", countryCode: "IT", coords: [10.9916, 45.4384], costOfLiving: 71 },
  { name: "Padua", country: "Italy", countryCode: "IT", coords: [11.8767, 45.4064], costOfLiving: 69 },
  { name: "Trieste", country: "Italy", countryCode: "IT", coords: [13.7681, 45.6495], costOfLiving: 68 },
  
  // Sweden (40+ jobs) - Nordic innovation hub
  { name: "Stockholm", country: "Sweden", countryCode: "SE", coords: [18.0686, 59.3293], costOfLiving: 95 },
  { name: "Gothenburg", country: "Sweden", countryCode: "SE", coords: [11.9746, 57.7089], costOfLiving: 85 },
  { name: "Malmö", country: "Sweden", countryCode: "SE", coords: [13.0038, 55.6050], costOfLiving: 82 },
  { name: "Uppsala", country: "Sweden", countryCode: "SE", coords: [17.6389, 59.8586], costOfLiving: 80 },
  { name: "Västerås", country: "Sweden", countryCode: "SE", coords: [16.5448, 59.6099], costOfLiving: 78 },
  { name: "Örebro", country: "Sweden", countryCode: "SE", coords: [15.2066, 59.2741], costOfLiving: 76 },
  { name: "Linköping", country: "Sweden", countryCode: "SE", coords: [15.6214, 58.4108], costOfLiving: 77 },
  { name: "Helsingborg", country: "Sweden", countryCode: "SE", coords: [12.6945, 56.0465], costOfLiving: 79 },
  { name: "Jönköping", country: "Sweden", countryCode: "SE", coords: [14.1618, 57.7826], costOfLiving: 75 },
  { name: "Norrköping", country: "Sweden", countryCode: "SE", coords: [16.1932, 58.5877], costOfLiving: 74 },
  
  // Switzerland (40+ jobs) - Finance & pharma center
  { name: "Zurich", country: "Switzerland", countryCode: "CH", coords: [8.5417, 47.3769], costOfLiving: 140 },
  { name: "Geneva", country: "Switzerland", countryCode: "CH", coords: [6.1432, 46.2044], costOfLiving: 135 },
  { name: "Basel", country: "Switzerland", countryCode: "CH", coords: [7.5886, 47.5596], costOfLiving: 125 },
  { name: "Bern", country: "Switzerland", countryCode: "CH", coords: [7.4474, 46.9480], costOfLiving: 120 },
  { name: "Lausanne", country: "Switzerland", countryCode: "CH", coords: [6.6323, 46.5197], costOfLiving: 118 },
  { name: "Winterthur", country: "Switzerland", countryCode: "CH", coords: [8.7233, 47.4979], costOfLiving: 115 },
  { name: "Lucerne", country: "Switzerland", countryCode: "CH", coords: [8.3093, 47.0502], costOfLiving: 112 },
  { name: "St. Gallen", country: "Switzerland", countryCode: "CH", coords: [9.3767, 47.4245], costOfLiving: 110 },
  { name: "Lugano", country: "Switzerland", countryCode: "CH", coords: [8.9511, 46.0037], costOfLiving: 108 },
  { name: "Biel", country: "Switzerland", countryCode: "CH", coords: [7.2544, 47.1368], costOfLiving: 105 },
  
  // Austria (40+ jobs) - Central European hub
  { name: "Vienna", country: "Austria", countryCode: "AT", coords: [16.3738, 48.2082], costOfLiving: 80 },
  { name: "Graz", country: "Austria", countryCode: "AT", coords: [15.4395, 47.0707], costOfLiving: 72 },
  { name: "Linz", country: "Austria", countryCode: "AT", coords: [14.2858, 48.3069], costOfLiving: 70 },
  { name: "Salzburg", country: "Austria", countryCode: "AT", coords: [13.0550, 47.8095], costOfLiving: 75 },
  { name: "Innsbruck", country: "Austria", countryCode: "AT", coords: [11.4041, 47.2692], costOfLiving: 78 },
  { name: "Klagenfurt", country: "Austria", countryCode: "AT", coords: [14.3050, 46.6247], costOfLiving: 68 },
  { name: "Villach", country: "Austria", countryCode: "AT", coords: [13.8558, 46.6111], costOfLiving: 66 },
  { name: "Wels", country: "Austria", countryCode: "AT", coords: [14.0298, 48.1598], costOfLiving: 67 },
  { name: "Sankt Pölten", country: "Austria", countryCode: "AT", coords: [15.6251, 48.2058], costOfLiving: 65 },
  { name: "Dornbirn", country: "Austria", countryCode: "AT", coords: [9.7414, 47.4125], costOfLiving: 73 },
  
  // Belgium (40+ jobs) - EU headquarters
  { name: "Brussels", country: "Belgium", countryCode: "BE", coords: [4.3517, 50.8503], costOfLiving: 85 },
  { name: "Antwerp", country: "Belgium", countryCode: "BE", coords: [4.4024, 51.2194], costOfLiving: 78 },
  { name: "Ghent", country: "Belgium", countryCode: "BE", coords: [3.7174, 51.0543], costOfLiving: 72 },
  { name: "Charleroi", country: "Belgium", countryCode: "BE", coords: [4.4444, 50.4108], costOfLiving: 68 },
  { name: "Liège", country: "Belgium", countryCode: "BE", coords: [5.5797, 50.6326], costOfLiving: 70 },
  { name: "Bruges", country: "Belgium", countryCode: "BE", coords: [3.2247, 51.2085], costOfLiving: 74 },
  { name: "Namur", country: "Belgium", countryCode: "BE", coords: [4.8723, 50.4674], costOfLiving: 69 },
  { name: "Leuven", country: "Belgium", countryCode: "BE", coords: [4.7005, 50.8798], costOfLiving: 76 },
  { name: "Mons", country: "Belgium", countryCode: "BE", coords: [3.9569, 50.4542], costOfLiving: 67 },
  { name: "Aalst", country: "Belgium", countryCode: "BE", coords: [4.0435, 50.9368], costOfLiving: 71 },
  
  // Denmark (40+ jobs) - Nordic welfare model
  { name: "Copenhagen", country: "Denmark", countryCode: "DK", coords: [12.5683, 55.6761], costOfLiving: 105 },
  { name: "Aarhus", country: "Denmark", countryCode: "DK", coords: [10.2039, 56.1629], costOfLiving: 88 },
  { name: "Odense", country: "Denmark", countryCode: "DK", coords: [10.4036, 55.4038], costOfLiving: 82 },
  { name: "Aalborg", country: "Denmark", countryCode: "DK", coords: [9.9187, 57.0488], costOfLiving: 80 },
  { name: "Esbjerg", country: "Denmark", countryCode: "DK", coords: [8.4522, 55.4659], costOfLiving: 78 },
  { name: "Randers", country: "Denmark", countryCode: "DK", coords: [10.0378, 56.4607], costOfLiving: 76 },
  { name: "Kolding", country: "Denmark", countryCode: "DK", coords: [9.4721, 55.4904], costOfLiving: 77 },
  { name: "Horsens", country: "Denmark", countryCode: "DK", coords: [9.8501, 55.8607], costOfLiving: 75 },
  { name: "Vejle", country: "Denmark", countryCode: "DK", coords: [9.5357, 55.7090], costOfLiving: 79 },
  { name: "Roskilde", country: "Denmark", countryCode: "DK", coords: [12.0803, 55.6418], costOfLiving: 83 },
  
  // Poland (40+ jobs) - Major Central European economy
  { name: "Warsaw", country: "Poland", countryCode: "PL", coords: [21.0122, 52.2297], costOfLiving: 65 },
  { name: "Krakow", country: "Poland", countryCode: "PL", coords: [19.9449, 50.0647], costOfLiving: 60 },
  { name: "Gdansk", country: "Poland", countryCode: "PL", coords: [18.6466, 54.3520], costOfLiving: 58 },
  { name: "Wroclaw", country: "Poland", countryCode: "PL", coords: [17.0385, 51.1079], costOfLiving: 57 },
  { name: "Poznan", country: "Poland", countryCode: "PL", coords: [16.9251, 52.4064], costOfLiving: 56 },
  { name: "Lodz", country: "Poland", countryCode: "PL", coords: [19.4514, 51.7592], costOfLiving: 52 },
  { name: "Katowice", country: "Poland", countryCode: "PL", coords: [19.0238, 50.2649], costOfLiving: 54 },
  { name: "Lublin", country: "Poland", countryCode: "PL", coords: [22.5684, 51.2465], costOfLiving: 50 },
  { name: "Bydgoszcz", country: "Poland", countryCode: "PL", coords: [18.0076, 53.1235], costOfLiving: 48 },
  { name: "Szczecin", country: "Poland", countryCode: "PL", coords: [14.5528, 53.4285], costOfLiving: 49 },
  
  // Czech Republic (40+ jobs) - Central European tech hub
  { name: "Prague", country: "Czech Republic", countryCode: "CZ", coords: [14.4378, 50.0755], costOfLiving: 62 },
  { name: "Brno", country: "Czech Republic", countryCode: "CZ", coords: [16.6068, 49.1951], costOfLiving: 55 },
  { name: "Ostrava", country: "Czech Republic", countryCode: "CZ", coords: [18.2820, 49.8209], costOfLiving: 52 },
  { name: "Plzen", country: "Czech Republic", countryCode: "CZ", coords: [13.3775, 49.7384], costOfLiving: 50 },
  { name: "Liberec", country: "Czech Republic", countryCode: "CZ", coords: [15.0543, 50.7671], costOfLiving: 48 },
  { name: "Olomouc", country: "Czech Republic", countryCode: "CZ", coords: [17.2509, 49.5938], costOfLiving: 47 },
  { name: "Ceske Budejovice", country: "Czech Republic", countryCode: "CZ", coords: [14.4743, 48.9744], costOfLiving: 46 },
  { name: "Hradec Kralove", country: "Czech Republic", countryCode: "CZ", coords: [15.8327, 50.2103], costOfLiving: 45 },
  { name: "Pardubice", country: "Czech Republic", countryCode: "CZ", coords: [15.7761, 50.0404], costOfLiving: 44 },
  { name: "Usti nad Labem", country: "Czech Republic", countryCode: "CZ", coords: [14.0343, 50.6607], costOfLiving: 43 },
  
  // Hungary (40+ jobs) - Eastern European hub
  { name: "Budapest", country: "Hungary", countryCode: "HU", coords: [19.0402, 47.4979], costOfLiving: 58 },
  { name: "Debrecen", country: "Hungary", countryCode: "HU", coords: [21.6273, 47.5316], costOfLiving: 48 },
  { name: "Szeged", country: "Hungary", countryCode: "HU", coords: [20.1414, 46.2530], costOfLiving: 46 },
  { name: "Miskolc", country: "Hungary", countryCode: "HU", coords: [20.7784, 48.1034], costOfLiving: 44 },
  { name: "Pecs", country: "Hungary", countryCode: "HU", coords: [18.2328, 46.0727], costOfLiving: 43 },
  { name: "Gyor", country: "Hungary", countryCode: "HU", coords: [17.6352, 47.6875], costOfLiving: 45 },
  { name: "Nyiregyhaza", country: "Hungary", countryCode: "HU", coords: [21.7174, 47.9559], costOfLiving: 42 },
  { name: "Kecskemet", country: "Hungary", countryCode: "HU", coords: [19.6914, 46.9073], costOfLiving: 41 },
  { name: "Szekesfehervar", country: "Hungary", countryCode: "HU", coords: [18.4108, 47.1925], costOfLiving: 43 },
  { name: "Szombathely", country: "Hungary", countryCode: "HU", coords: [16.6218, 47.2309], costOfLiving: 40 },
  
  // Romania (40+ jobs) - Growing Eastern European market
  { name: "Bucharest", country: "Romania", countryCode: "RO", coords: [26.1025, 44.4268], costOfLiving: 52 },
  { name: "Cluj-Napoca", country: "Romania", countryCode: "RO", coords: [23.6236, 46.7712], costOfLiving: 45 },
  { name: "Timisoara", country: "Romania", countryCode: "RO", coords: [21.2257, 45.7494], costOfLiving: 43 },
  { name: "Iasi", country: "Romania", countryCode: "RO", coords: [27.6014, 47.1585], costOfLiving: 40 },
  { name: "Constanta", country: "Romania", countryCode: "RO", coords: [28.6348, 44.1598], costOfLiving: 41 },
  { name: "Craiova", country: "Romania", countryCode: "RO", coords: [23.8014, 44.3302], costOfLiving: 38 },
  { name: "Brasov", country: "Romania", countryCode: "RO", coords: [25.6012, 45.6579], costOfLiving: 42 },
  { name: "Galati", country: "Romania", countryCode: "RO", coords: [28.0578, 45.4353], costOfLiving: 37 },
  { name: "Ploiesti", country: "Romania", countryCode: "RO", coords: [26.0157, 44.9414], costOfLiving: 39 },
  { name: "Oradea", country: "Romania", countryCode: "RO", coords: [21.9211, 47.0722], costOfLiving: 38 },
  
  // Slovakia (40+ jobs) - Central European economy
  { name: "Bratislava", country: "Slovakia", countryCode: "SK", coords: [17.1077, 48.1482], costOfLiving: 60 },
  { name: "Kosice", country: "Slovakia", countryCode: "SK", coords: [21.2611, 48.7164], costOfLiving: 50 },
  { name: "Presov", country: "Slovakia", countryCode: "SK", coords: [21.2393, 49.0018], costOfLiving: 45 },
  { name: "Zilina", country: "Slovakia", countryCode: "SK", coords: [18.7408, 49.2233], costOfLiving: 47 },
  { name: "Nitra", country: "Slovakia", countryCode: "SK", coords: [18.0711, 48.3081], costOfLiving: 44 },
  { name: "Banska Bystrica", country: "Slovakia", countryCode: "SK", coords: [19.1546, 48.7372], costOfLiving: 43 },
  { name: "Trnava", country: "Slovakia", countryCode: "SK", coords: [17.5893, 48.3774], costOfLiving: 46 },
  { name: "Martin", country: "Slovakia", countryCode: "SK", coords: [18.9208, 49.0664], costOfLiving: 42 },
  { name: "Trencin", country: "Slovakia", countryCode: "SK", coords: [18.0446, 48.8946], costOfLiving: 44 },
  { name: "Poprad", country: "Slovakia", countryCode: "SK", coords: [20.2988, 49.0611], costOfLiving: 41 },
  
  // Slovenia (40+ jobs) - Alpine business hub
  { name: "Ljubljana", country: "Slovenia", countryCode: "SI", coords: [14.5058, 46.0569], costOfLiving: 68 },
  { name: "Maribor", country: "Slovenia", countryCode: "SI", coords: [15.6378, 46.5547], costOfLiving: 58 },
  { name: "Celje", country: "Slovenia", countryCode: "SI", coords: [15.2677, 46.2311], costOfLiving: 55 },
  { name: "Kranj", country: "Slovenia", countryCode: "SI", coords: [14.3552, 46.2394], costOfLiving: 60 },
  { name: "Velenje", country: "Slovenia", countryCode: "SI", coords: [15.1115, 46.3592], costOfLiving: 52 },
  { name: "Koper", country: "Slovenia", countryCode: "SI", coords: [13.7301, 45.5469], costOfLiving: 56 },
  { name: "Novo Mesto", country: "Slovenia", countryCode: "SI", coords: [15.1683, 45.8051], costOfLiving: 53 },
  { name: "Ptuj", country: "Slovenia", countryCode: "SI", coords: [15.8697, 46.4203], costOfLiving: 50 },
  { name: "Kamnik", country: "Slovenia", countryCode: "SI", coords: [14.6117, 46.2267], costOfLiving: 54 },
  { name: "Jesenice", country: "Slovenia", countryCode: "SI", coords: [14.0594, 46.4301], costOfLiving: 51 },
  
  // Croatia (40+ jobs) - Adriatic business center
  { name: "Zagreb", country: "Croatia", countryCode: "HR", coords: [15.9819, 45.8150], costOfLiving: 60 },
  { name: "Split", country: "Croatia", countryCode: "HR", coords: [16.4402, 43.5081], costOfLiving: 52 },
  { name: "Rijeka", country: "Croatia", countryCode: "HR", coords: [14.4378, 45.3371], costOfLiving: 50 },
  { name: "Osijek", country: "Croatia", countryCode: "HR", coords: [18.6956, 45.5550], costOfLiving: 45 },
  { name: "Zadar", country: "Croatia", countryCode: "HR", coords: [15.2314, 44.1194], costOfLiving: 47 },
  { name: "Pula", country: "Croatia", countryCode: "HR", coords: [13.8481, 44.8666], costOfLiving: 49 },
  { name: "Slavonski Brod", country: "Croatia", countryCode: "HR", coords: [18.0158, 45.1601], costOfLiving: 42 },
  { name: "Karlovac", country: "Croatia", countryCode: "HR", coords: [15.5553, 45.4870], costOfLiving: 44 },
  { name: "Varazdin", country: "Croatia", countryCode: "HR", coords: [16.3378, 46.3044], costOfLiving: 46 },
  { name: "Sibenik", country: "Croatia", countryCode: "HR", coords: [15.8952, 43.7384], costOfLiving: 43 },
  
  // Estonia (40+ jobs) - Baltic digital leader
  { name: "Tallinn", country: "Estonia", countryCode: "EE", coords: [24.7536, 59.4370], costOfLiving: 70 },
  { name: "Tartu", country: "Estonia", countryCode: "EE", coords: [26.7290, 58.3776], costOfLiving: 60 },
  { name: "Narva", country: "Estonia", countryCode: "EE", coords: [28.1907, 59.3753], costOfLiving: 55 },
  { name: "Parnu", country: "Estonia", countryCode: "EE", coords: [24.4971, 58.3859], costOfLiving: 58 },
  { name: "Kohtla-Jarve", country: "Estonia", countryCode: "EE", coords: [27.2728, 59.3986], costOfLiving: 52 },
  { name: "Viljandi", country: "Estonia", countryCode: "EE", coords: [25.5901, 58.3639], costOfLiving: 50 },
  { name: "Rakvere", country: "Estonia", countryCode: "EE", coords: [26.3564, 59.3465], costOfLiving: 53 },
  { name: "Maardu", country: "Estonia", countryCode: "EE", coords: [24.9825, 59.4653], costOfLiving: 54 },
  { name: "Sillamae", country: "Estonia", countryCode: "EE", coords: [27.7631, 59.3969], costOfLiving: 51 },
  { name: "Kuressaare", country: "Estonia", countryCode: "EE", coords: [22.4856, 58.2531], costOfLiving: 56 },
  
  // Latvia (40+ jobs) - Baltic finance hub
  { name: "Riga", country: "Latvia", countryCode: "LV", coords: [24.1052, 56.9496], costOfLiving: 65 },
  { name: "Daugavpils", country: "Latvia", countryCode: "LV", coords: [26.5361, 55.8747], costOfLiving: 52 },
  { name: "Liepaja", country: "Latvia", countryCode: "LV", coords: [21.0159, 56.5055], costOfLiving: 54 },
  { name: "Jelgava", country: "Latvia", countryCode: "LV", coords: [23.7134, 56.6505], costOfLiving: 50 },
  { name: "Jurmala", country: "Latvia", countryCode: "LV", coords: [23.7717, 56.9681], costOfLiving: 58 },
  { name: "Ventspils", country: "Latvia", countryCode: "LV", coords: [21.5644, 57.3894], costOfLiving: 53 },
  { name: "Rezekne", country: "Latvia", countryCode: "LV", coords: [27.3167, 56.5089], costOfLiving: 48 },
  { name: "Valmiera", country: "Latvia", countryCode: "LV", coords: [25.4272, 57.5411], costOfLiving: 49 },
  { name: "Jekabpils", country: "Latvia", countryCode: "LV", coords: [25.8603, 56.4989], costOfLiving: 47 },
  { name: "Ogre", country: "Latvia", countryCode: "LV", coords: [24.6139, 56.8167], costOfLiving: 51 },
  
  // Lithuania (40+ jobs) - Baltic innovation center
  { name: "Vilnius", country: "Lithuania", countryCode: "LT", coords: [25.2797, 54.6872], costOfLiving: 62 },
  { name: "Kaunas", country: "Lithuania", countryCode: "LT", coords: [23.9036, 54.8985], costOfLiving: 55 },
  { name: "Klaipeda", country: "Lithuania", countryCode: "LT", coords: [21.1175, 55.7172], costOfLiving: 57 },
  { name: "Siauliai", country: "Lithuania", countryCode: "LT", coords: [23.3156, 55.9349], costOfLiving: 48 },
  { name: "Panevezys", country: "Lithuania", countryCode: "LT", coords: [24.3603, 55.7322], costOfLiving: 46 },
  { name: "Alytus", country: "Lithuania", countryCode: "LT", coords: [24.0456, 54.3964], costOfLiving: 44 },
  { name: "Marijampole", country: "Lithuania", countryCode: "LT", coords: [23.3544, 54.5592], costOfLiving: 43 },
  { name: "Mazeikiai", country: "Lithuania", countryCode: "LT", coords: [22.3431, 56.3081], costOfLiving: 45 },
  { name: "Jonava", country: "Lithuania", countryCode: "LT", coords: [24.2778, 55.0731], costOfLiving: 42 },
  { name: "Utena", country: "Lithuania", countryCode: "LT", coords: [25.5986, 55.4975], costOfLiving: 41 },
];

// US cities (30 jobs)
const usCities = [
  { name: "San Francisco", state: "CA", coords: [-122.4194, 37.7749], costOfLiving: 150 },
  { name: "New York", state: "NY", coords: [-74.0060, 40.7128], costOfLiving: 130 },
  { name: "Seattle", state: "WA", coords: [-122.3321, 47.6062], costOfLiving: 125 },
  { name: "Austin", state: "TX", coords: [-97.7431, 30.2672], costOfLiving: 95 },
  { name: "Boston", state: "MA", coords: [-71.0589, 42.3601], costOfLiving: 120 },
  { name: "Los Angeles", state: "CA", coords: [-118.2437, 34.0522], costOfLiving: 140 },
  { name: "Chicago", state: "IL", coords: [-87.6298, 41.8781], costOfLiving: 105 },
  { name: "Denver", state: "CO", coords: [-104.9903, 39.7392], costOfLiving: 110 },
  { name: "Atlanta", state: "GA", coords: [-84.3880, 33.7490], costOfLiving: 90 },
  { name: "Miami", state: "FL", coords: [-80.1918, 25.7617], costOfLiving: 115 },
  { name: "Portland", state: "OR", coords: [-122.6784, 45.5152], costOfLiving: 115 },
  { name: "Dallas", state: "TX", coords: [-96.7970, 32.7767], costOfLiving: 95 },
  { name: "San Diego", state: "CA", coords: [-117.1611, 32.7157], costOfLiving: 135 },
  { name: "Philadelphia", state: "PA", coords: [-75.1652, 39.9526], costOfLiving: 105 },
  { name: "Phoenix", state: "AZ", coords: [-112.0740, 33.4484], costOfLiving: 100 },
  { name: "Nashville", state: "TN", coords: [-86.7816, 36.1627], costOfLiving: 95 },
  { name: "Raleigh", state: "NC", coords: [-78.6382, 35.7796], costOfLiving: 90 },
  { name: "Minneapolis", state: "MN", coords: [-93.2650, 44.9778], costOfLiving: 100 },
  { name: "Pittsburgh", state: "PA", coords: [-79.9959, 40.4406], costOfLiving: 85 },
  { name: "Salt Lake City", state: "UT", coords: [-111.8910, 40.7608], costOfLiving: 95 },
  { name: "Tampa", state: "FL", coords: [-82.4572, 27.9506], costOfLiving: 95 },
  { name: "Kansas City", state: "MO", coords: [-94.5786, 39.0997], costOfLiving: 85 },
  { name: "Sacramento", state: "CA", coords: [-121.4686, 38.5556], costOfLiving: 120 },
  { name: "Columbus", state: "OH", coords: [-82.9988, 39.9612], costOfLiving: 85 },
  { name: "Indianapolis", state: "IN", coords: [-86.1581, 39.7684], costOfLiving: 80 },
  { name: "Charlotte", state: "NC", coords: [-80.8431, 35.2271], costOfLiving: 90 },
  { name: "Virginia Beach", state: "VA", coords: [-75.9778, 36.8529], costOfLiving: 95 },
  { name: "Milwaukee", state: "WI", coords: [-87.9065, 43.0389], costOfLiving: 85 },
  { name: "Las Vegas", state: "NV", coords: [-115.1398, 36.1699], costOfLiving: 105 },
  { name: "Detroit", state: "MI", coords: [-83.0458, 42.3314], costOfLiving: 75 },
];

// Rest of world cities (300 jobs distributed globally)
const worldCities = [
  // Canada (30 jobs)
  { name: "Toronto", country: "Canada", coords: [-79.3832, 43.6532], costOfLiving: 105 },
  { name: "Vancouver", country: "Canada", coords: [-123.1207, 49.2827], costOfLiving: 110 },
  { name: "Montreal", country: "Canada", coords: [-73.5673, 45.5017], costOfLiving: 90 },
  { name: "Calgary", country: "Canada", coords: [-114.0719, 51.0447], costOfLiving: 95 },
  { name: "Ottawa", country: "Canada", coords: [-75.6972, 45.4215], costOfLiving: 95 },
  // Add more Canadian cities...
  
  // Australia (25 jobs)
  { name: "Sydney", country: "Australia", coords: [151.2093, -33.8688], costOfLiving: 115 },
  { name: "Melbourne", country: "Australia", coords: [144.9631, -37.8136], costOfLiving: 110 },
  { name: "Brisbane", country: "Australia", coords: [153.0251, -27.4698], costOfLiving: 100 },
  { name: "Perth", country: "Australia", coords: [115.8605, -31.9505], costOfLiving: 105 },
  { name: "Adelaide", country: "Australia", coords: [138.6007, -34.9285], costOfLiving: 95 },
  // Add more Australian cities...
  
  // India (50 jobs)
  { name: "Bangalore", country: "India", coords: [77.5946, 12.9716], costOfLiving: 35 },
  { name: "Mumbai", country: "India", coords: [72.8777, 19.0760], costOfLiving: 40 },
  { name: "Delhi", country: "India", coords: [77.1025, 28.7041], costOfLiving: 38 },
  { name: "Hyderabad", country: "India", coords: [78.4867, 17.3850], costOfLiving: 32 },
  { name: "Chennai", country: "India", coords: [80.2707, 13.0827], costOfLiving: 35 },
  { name: "Pune", country: "India", coords: [73.8567, 18.5204], costOfLiving: 33 },
  // Add more Indian cities...
  
  // Japan (20 jobs)
  { name: "Tokyo", country: "Japan", coords: [139.6917, 35.6895], costOfLiving: 120 },
  { name: "Osaka", country: "Japan", coords: [135.5023, 34.6937], costOfLiving: 100 },
  { name: "Kyoto", country: "Japan", coords: [135.7681, 35.0116], costOfLiving: 95 },
  { name: "Yokohama", country: "Japan", coords: [139.6380, 35.4437], costOfLiving: 115 },
  // Add more Japanese cities...
  
  // Singapore (15 jobs)
  { name: "Singapore", country: "Singapore", coords: [103.8198, 1.3521], costOfLiving: 125 },
  
  // Israel (15 jobs)
  { name: "Tel Aviv", country: "Israel", coords: [34.7818, 32.0853], costOfLiving: 110 },
  { name: "Jerusalem", country: "Israel", coords: [35.2137, 31.7683], costOfLiving: 100 },
  { name: "Haifa", country: "Israel", coords: [34.9896, 32.7940], costOfLiving: 95 },
  
  // South Korea (15 jobs)
  { name: "Seoul", country: "South Korea", coords: [126.9780, 37.5665], costOfLiving: 85 },
  { name: "Busan", country: "South Korea", coords: [129.0756, 35.1796], costOfLiving: 75 },
  
  // Brazil (25 jobs)
  { name: "São Paulo", country: "Brazil", coords: [-46.6333, -23.5505], costOfLiving: 55 },
  { name: "Rio de Janeiro", country: "Brazil", coords: [-43.1729, -22.9068], costOfLiving: 60 },
  { name: "Belo Horizonte", country: "Brazil", coords: [-43.9378, -19.9281], costOfLiving: 50 },
  
  // Mexico (20 jobs)
  { name: "Mexico City", country: "Mexico", coords: [-99.1332, 19.4326], costOfLiving: 45 },
  { name: "Guadalajara", country: "Mexico", coords: [-103.3496, 20.6597], costOfLiving: 40 },
  { name: "Monterrey", country: "Mexico", coords: [-100.3161, 25.6866], costOfLiving: 45 },
  
  // Additional countries to reach 300 total
  { name: "Dubai", country: "UAE", coords: [55.2708, 25.2048], costOfLiving: 90 },
  { name: "Buenos Aires", country: "Argentina", coords: [-58.3816, -34.6037], costOfLiving: 45 },
  { name: "Santiago", country: "Chile", coords: [-70.6693, -33.4489], costOfLiving: 60 },
  { name: "Cape Town", country: "South Africa", coords: [18.4241, -33.9249], costOfLiving: 50 },
  { name: "Lagos", country: "Nigeria", coords: [3.3792, 6.5244], costOfLiving: 30 },
  { name: "Cairo", country: "Egypt", coords: [31.2357, 30.0444], costOfLiving: 25 },
  { name: "Istanbul", country: "Turkey", coords: [28.9784, 41.0082], costOfLiving: 45 },
  { name: "Bangkok", country: "Thailand", coords: [100.5018, 13.7563], costOfLiving: 40 },
  { name: "Ho Chi Minh City", country: "Vietnam", coords: [106.6297, 10.8231], costOfLiving: 35 },
  { name: "Manila", country: "Philippines", coords: [120.9842, 14.5995], costOfLiving: 35 },
  { name: "Jakarta", country: "Indonesia", coords: [106.8451, -6.2088], costOfLiving: 35 },
  { name: "Kuala Lumpur", country: "Malaysia", coords: [101.6869, 3.1390], costOfLiving: 45 },
];

// Comprehensive job titles across multiple industries (easy to relocate positions)
const jobTitles = [
  // Technology & Engineering
  "Senior Software Engineer", "Frontend Developer", "Backend Developer", "Full Stack Developer",
  "DevOps Engineer", "Data Scientist", "Machine Learning Engineer", "Product Manager",
  "UX Designer", "UI Designer", "Cloud Architect", "Security Engineer",
  "Mobile Developer", "QA Engineer", "Technical Lead", "Engineering Manager",
  "Data Analyst", "Business Analyst", "Scrum Master", "Solutions Architect",
  "Cybersecurity Specialist", "AI Research Scientist", "Blockchain Developer", "Site Reliability Engineer",
  
  // Finance & Banking
  "Financial Analyst", "Investment Banking Analyst", "Risk Management Specialist", "Quantitative Analyst",
  "Portfolio Manager", "Financial Controller", "Treasury Analyst", "Credit Risk Analyst",
  "Compliance Officer", "Private Equity Associate", "Hedge Fund Analyst", "Corporate Finance Manager",
  "Derivatives Trader", "Foreign Exchange Analyst", "Financial Planning Analyst", "Investment Advisor",
  "Mergers & Acquisitions Analyst", "Asset Management Specialist", "Financial Technology Consultant",
  "ESG Investment Analyst", "Wealth Management Advisor", "Insurance Underwriter",
  
  // Healthcare & Medical
  "Medical Doctor", "Nurse Practitioner", "Clinical Research Coordinator", "Biomedical Engineer",
  "Pharmacist", "Medical Device Specialist", "Healthcare Data Analyst", "Telemedicine Physician",
  "Medical Affairs Manager", "Clinical Trial Manager", "Regulatory Affairs Specialist",
  "Healthcare IT Consultant", "Medical Writer", "Health Economics Researcher", "Epidemiologist",
  "Public Health Analyst", "Healthcare Quality Analyst", "Medical Laboratory Scientist",
  "Radiologic Technologist", "Physical Therapist", "Occupational Therapist",
  
  // Consulting & Professional Services
  "Management Consultant", "Strategy Consultant", "Business Process Consultant", "IT Consultant",
  "Digital Transformation Consultant", "Supply Chain Consultant", "HR Consultant",
  "Financial Advisory Consultant", "Sustainability Consultant", "Change Management Consultant",
  "Operations Consultant", "Technology Implementation Consultant", "Risk Advisory Consultant",
  "M&A Advisory Consultant", "Organizational Development Consultant", "Performance Improvement Consultant",
  
  // Marketing & Communications
  "Digital Marketing Manager", "Brand Manager", "Content Marketing Specialist", "SEO Specialist",
  "Social Media Manager", "Marketing Data Analyst", "Growth Marketing Manager", "PR Manager",
  "Communications Specialist", "Event Marketing Manager", "Email Marketing Specialist",
  "Performance Marketing Manager", "Marketing Automation Specialist", "Influencer Marketing Manager",
  
  // Sales & Business Development
  "Sales Manager", "Business Development Manager", "Account Executive", "Key Account Manager",
  "Sales Operations Analyst", "Revenue Operations Manager", "Customer Success Manager",
  "Sales Development Representative", "Enterprise Sales Executive", "Channel Partner Manager",
  "Sales Engineer", "Technical Sales Specialist", "International Sales Manager",
  
  // Legal & Compliance
  "Corporate Lawyer", "Legal Counsel", "Compliance Manager", "Contract Manager",
  "Intellectual Property Lawyer", "Data Privacy Officer", "Legal Operations Manager",
  "Regulatory Compliance Specialist", "Legal Technology Specialist", "In-house Counsel",
  
  // Research & Development
  "Research Scientist", "Clinical Research Associate", "R&D Manager", "Innovation Manager",
  "Product Development Engineer", "Research Data Analyst", "Laboratory Manager",
  "Technical Research Specialist", "Patent Analyst", "Scientific Writer",
  
  // Project & Operations Management
  "Project Manager", "Program Manager", "Operations Manager", "Supply Chain Manager",
  "Logistics Coordinator", "Process Improvement Manager", "Quality Assurance Manager",
  "Procurement Specialist", "Vendor Management Specialist", "Facilities Manager",
  
  // Human Resources & Talent
  "HR Business Partner", "Talent Acquisition Specialist", "Compensation Analyst",
  "Learning & Development Manager", "HR Data Analyst", "Employee Relations Specialist",
  "Organizational Development Specialist", "HR Technology Specialist", "Diversity & Inclusion Manager",
  
  // International & Remote-Friendly Roles
  "International Business Manager", "Global Operations Manager", "Remote Work Coordinator",
  "Virtual Team Manager", "International Project Coordinator", "Global Communications Manager",
  "Cross-Cultural Training Specialist", "International Compliance Manager", "Global HR Manager",
  
  // Creative & Design
  "Graphic Designer", "Creative Director", "Art Director", "Motion Graphics Designer",
  "Visual Designer", "Brand Identity Designer", "Packaging Designer", "Web Designer",
  "Illustration Specialist", "Creative Strategist", "Design Research Specialist"
];

const companies = [
  // Technology Companies
  "Microsoft", "Google", "Amazon", "Meta", "Apple", "Netflix", "Spotify",
  "Uber", "Airbnb", "Tesla", "SpaceX", "Stripe", "Slack", "Zoom",
  "Shopify", "Square", "PayPal", "Salesforce", "Adobe", "Oracle",
  "TechCorp", "InnovateSoft", "DataDynamics", "CloudSolutions", "NextGen Systems",
  "DigitalFirst", "CodeCrafters", "SmartTech", "FutureSoft", "TechPioneers",
  
  // Financial Services
  "Goldman Sachs", "JPMorgan Chase", "Morgan Stanley", "Deutsche Bank", "UBS",
  "Credit Suisse", "Barclays", "HSBC", "BNP Paribas", "Société Générale",
  "ING Group", "Santander", "UniCredit", "Allianz", "AXA", "Zurich Insurance",
  "BlackRock", "Vanguard", "State Street", "Fidelity", "T. Rowe Price",
  "FinanceFirst", "Global Investments", "Alpha Capital", "Meridian Bank",
  
  // Healthcare & Pharmaceuticals
  "Pfizer", "Johnson & Johnson", "Roche", "Novartis", "Sanofi", "GSK",
  "AstraZeneca", "Merck", "Bristol Myers Squibb", "AbbVie", "Gilead",
  "Moderna", "BioNTech", "Novo Nordisk", "Eli Lilly", "Bayer",
  "Philips Healthcare", "Siemens Healthineers", "GE Healthcare", "Medtronic",
  "HealthTech Solutions", "MedInnovate", "BioLife Sciences", "CareFirst Medical",
  
  // Consulting Firms
  "McKinsey & Company", "Boston Consulting Group", "Bain & Company", "Deloitte",
  "PwC", "EY", "KPMG", "Accenture", "IBM Consulting", "Capgemini",
  "Roland Berger", "Oliver Wyman", "A.T. Kearney", "L.E.K. Consulting",
  "Strategy Partners", "Global Advisory", "Insight Consulting", "Nexus Strategy",
  
  // Multinational Corporations
  "Unilever", "Nestlé", "Procter & Gamble", "LVMH", "L'Oréal", "Danone",
  "Heineken", "AB InBev", "Coca-Cola", "PepsiCo", "Mars", "Mondelez",
  "BMW", "Mercedes-Benz", "Volkswagen", "Audi", "Porsche", "Ferrari",
  "Airbus", "Boeing", "Rolls-Royce", "Thales", "Leonardo", "BAE Systems",
  
  // Energy & Sustainability
  "Shell", "BP", "TotalEnergies", "Equinor", "Eni", "Repsol", "OMV",
  "Vestas", "Orsted", "Siemens Gamesa", "Enel", "RWE", "E.ON", "Vattenfall",
  "EnergyForward", "GreenTech Solutions", "Renewable Dynamics", "CleanEnergy Corp",
  
  // Media & Entertainment
  "Disney", "Warner Bros", "Universal", "Netflix", "Amazon Studios", "BBC",
  "Sky", "ITV", "RTL", "Vivendi", "Bertelsmann", "Publicis", "WPP", "Omnicom",
  "MediaFirst", "Creative Studios", "Digital Media Group", "Entertainment Plus",
  
  // Retail & E-commerce
  "Amazon", "Alibaba", "Zalando", "ASOS", "H&M", "Zara", "IKEA", "Carrefour",
  "Tesco", "Metro", "Lidl", "Aldi", "Decathlon", "MediaMarkt", "Otto Group",
  "RetailTech", "E-Commerce Solutions", "Digital Retail", "Shopping Innovation",
  
  // Telecommunications
  "Vodafone", "Orange", "Deutsche Telekom", "Telefónica", "TIM", "Telia",
  "KPN", "Proximus", "Swisscom", "A1 Telekom", "Telenor", "Three",
  "TelecomForward", "Global Communications", "Network Solutions", "ConnectTech"
];

const industries = [
  "Technology", "Finance & Banking", "Healthcare & Pharmaceuticals", "Consulting",
  "Telecommunications", "Energy & Utilities", "Media & Entertainment", "Retail & E-commerce",
  "Automotive", "Aerospace & Defense", "Insurance", "Real Estate", "Education",
  "Food & Beverage", "Fashion & Luxury", "Chemical & Materials", "Transportation & Logistics",
  "Construction & Engineering", "Agriculture & Food Production", "Professional Services",
  "Biotechnology", "Renewable Energy", "Gaming & Entertainment", "Sports & Recreation",
  "Travel & Hospitality", "Government & Public Sector", "Non-Profit", "Research & Development"
];

const employmentTypes = ["fulltime", "parttime", "contract", "freelance"];

// Function to generate salary based on location cost of living
function generateSalary(costOfLiving: number, isUS: boolean = false): number {
  const baseSalary = isUS ? 85000 : 55000; // Base salary in USD
  const adjustedSalary = baseSalary * (costOfLiving / 100);
  const variation = 0.3; // 30% variation
  const randomFactor = 1 + (Math.random() - 0.5) * variation;
  return Math.round(adjustedSalary * randomFactor);
}

// Experience levels
const experienceLevels = [
  "Entry level (0-2 years)", "Mid level (2-5 years)", "Senior level (5-8 years)", 
  "Staff level (8+ years)", "Principal level (10+ years)"
];

// Function to generate benefits package
function generateBenefits() {
  return {
    healthInsurance: Math.random() > 0.1, // 90% have health insurance
    retirement401k: Math.random() > 0.2, // 80% have 401k
    paidTimeOff: Math.floor(Math.random() * 20) + 15, // 15-35 days PTO
    stockOptions: Math.random() > 0.4, // 60% have stock options
    remoteWork: Math.random() > 0.3, // 70% allow remote work
    learningBudget: Math.floor(Math.random() * 4000) + 1000 // $1000-$5000 learning budget
  };
}

// Function to create job features
function createJobFeature(city: any, index: number, isUS: boolean = false): Feature<Point, JobProperties> {
  const title = jobTitles[Math.floor(Math.random() * jobTitles.length)];
  const company = companies[Math.floor(Math.random() * companies.length)];
  const industry = industries[Math.floor(Math.random() * industries.length)];
  const employmentType = employmentTypes[Math.floor(Math.random() * employmentTypes.length)];
  const isRemote = Math.random() < 0.3; // 30% chance of remote
  const salary = generateSalary(city.costOfLiving, isUS);
  const companyRating = Math.round((Math.random() * 2 + 3) * 10) / 10; // 3.0-5.0 rating
  const openPositions = Math.floor(Math.random() * 15) + 1; // 1-15 open positions
  const yearsOfExperience = experienceLevels[Math.floor(Math.random() * experienceLevels.length)];
  const benefits = generateBenefits();

  return {
    type: "Feature",
    properties: {
      id: `job${index}`,
      title,
      company,
      city: city.name,
      state: isUS ? city.state : undefined,
      countryCode: isUS ? "USA" : (city.countryCode || city.country?.substring(0, 2).toUpperCase()),
      salary,
      employmentType,
      remote: isRemote,
      industryTag: industry,
      costOfLiving: city.costOfLiving,
      companyRating,
      openPositions,
      benefits,
      yearsOfExperience,
      description: `${title} position at ${company}. Looking for ${yearsOfExperience.toLowerCase()} candidate to join our ${industry.toLowerCase()} team.`
    },
    geometry: {
      type: "Point",
      coordinates: city.coords
    }
  };
}

// Generate comprehensive mock data with many more positions
function generateComprehensiveJobData(): Feature<Point, JobProperties>[] {
  const features: Feature<Point, JobProperties>[] = [];
  let jobId = 1;

  // European jobs - Generate multiple jobs per city for comprehensive coverage
  // Each major EU country will have 40+ positions distributed across their cities
  europeanCities.forEach(city => {
    // Generate 2-4 jobs per city depending on city size and importance
    const jobsPerCity = city.name === "London" || city.name === "Paris" || city.name === "Berlin" || 
                       city.name === "Madrid" || city.name === "Rome" || city.name === "Amsterdam" ? 4 :
                       city.name === "Munich" || city.name === "Frankfurt" || city.name === "Milan" || 
                       city.name === "Barcelona" || city.name === "Lyon" || city.name === "Stockholm" ? 3 : 2;
    
    for (let i = 0; i < jobsPerCity; i++) {
      const jobFeature = createJobFeature(city, jobId++, false);
      features.push(jobFeature);
    }
  });

  // US jobs (30 jobs)
  usCities.forEach(city => {
    const jobFeature = createJobFeature(city, jobId++, true);
    features.push(jobFeature);
  });

  // Rest of world jobs (200+ jobs)
  for (let i = 0; i < 250; i++) {
    const cityIndex = i % worldCities.length;
    const city = worldCities[cityIndex];
    const jobFeature = createJobFeature(city, jobId++, false);
    features.push(jobFeature);
  }

  return features;
}

// Generate static job features with more data
const staticJobFeatures: Feature<Point, JobProperties>[] = generateComprehensiveJobData();

// Generate all job features
export function generateMockJobData(): JobMarketDataFeatureCollection {
  return {
    type: "FeatureCollection",
    features: staticJobFeatures
  };
}

// Company data for the companies tab
export const mockCompanyData = [
  {
    id: "1",
    name: "Google",
    industry: "Technology",
    description: "Multinational technology company specializing in Internet-related services and products.",
    size: "Large (10,000+ employees)",
    globalRating: 4.5,
    website: "https://google.com",
    foundedYear: 1998,
    tags: ["JavaScript", "Python", "Go", "Cloud", "AI/ML", "Kubernetes"],
    locations: [
      {
        id: "google-mv",
        city: "Mountain View",
        state: "CA",
        country: "USA",
        coordinates: [-122.0838, 37.4220] as [number, number],
        rating: 4.6,
        salaryRange: { min: 140000, max: 300000 },
        roles: [
          { title: "Software Engineer", count: 25, salaryRange: { min: 150000, max: 280000 } },
          { title: "Product Manager", count: 12, salaryRange: { min: 160000, max: 300000 } },
          { title: "Data Scientist", count: 18, salaryRange: { min: 140000, max: 250000 } }
        ]
      },
      {
        id: "google-nyc",
        city: "New York",
        state: "NY",
        country: "USA",
        coordinates: [-74.0060, 40.7128] as [number, number],
        rating: 4.4,
        salaryRange: { min: 135000, max: 290000 },
        roles: [
          { title: "Software Engineer", count: 20, salaryRange: { min: 145000, max: 270000 } },
          { title: "UX Designer", count: 8, salaryRange: { min: 135000, max: 220000 } }
        ]
      }
    ]
  },
  {
    id: "2",
    name: "Microsoft",
    industry: "Technology",
    description: "Multinational technology corporation producing computer software, consumer electronics, and services.",
    size: "Large (10,000+ employees)",
    globalRating: 4.4,
    website: "https://microsoft.com",
    foundedYear: 1975,
    tags: ["C#", ".NET", "Azure", "TypeScript", "React", "DevOps"],
    locations: [
      {
        id: "ms-redmond",
        city: "Redmond",
        state: "WA",
        country: "USA",
        coordinates: [-122.1215, 47.6740] as [number, number],
        rating: 4.5,
        salaryRange: { min: 130000, max: 280000 },
        roles: [
          { title: "Software Engineer", count: 30, salaryRange: { min: 140000, max: 260000 } },
          { title: "Program Manager", count: 15, salaryRange: { min: 130000, max: 280000 } },
          { title: "Cloud Engineer", count: 12, salaryRange: { min: 145000, max: 250000 } }
        ]
      },
      {
        id: "ms-sf",
        city: "San Francisco",
        state: "CA",
        country: "USA",
        coordinates: [-122.4194, 37.7749] as [number, number],
        rating: 4.3,
        salaryRange: { min: 145000, max: 300000 },
        roles: [
          { title: "Software Engineer", count: 22, salaryRange: { min: 155000, max: 280000 } },
          { title: "Data Scientist", count: 10, salaryRange: { min: 145000, max: 300000 } }
        ]
      }
    ]
  },
  {
    id: "3",
    name: "Meta",
    industry: "Technology",
    description: "Social technology company that helps people connect, find communities, and grow businesses.",
    size: "Large (10,000+ employees)",
    globalRating: 4.1,
    website: "https://meta.com",
    foundedYear: 2004,
    tags: ["React", "JavaScript", "Python", "PHP", "Mobile", "VR/AR"],
    locations: [
      {
        id: "meta-menlo",
        city: "Menlo Park",
        state: "CA",
        country: "USA",
        coordinates: [-122.1817, 37.4835] as [number, number],
        rating: 4.2,
        salaryRange: { min: 150000, max: 320000 },
        roles: [
          { title: "Software Engineer", count: 35, salaryRange: { min: 160000, max: 300000 } },
          { title: "Product Manager", count: 18, salaryRange: { min: 170000, max: 320000 } },
          { title: "Data Engineer", count: 15, salaryRange: { min: 150000, max: 280000 } }
        ]
      }
    ]
  },
  {
    id: "4",
    name: "Netflix",
    industry: "Entertainment",
    description: "World's leading streaming entertainment service with over 230 million members.",
    size: "Large (10,000+ employees)",
    globalRating: 4.3,
    website: "https://netflix.com",
    foundedYear: 1997,
    tags: ["Java", "Python", "Scala", "AWS", "Machine Learning", "Microservices"],
    locations: [
      {
        id: "netflix-lg",
        city: "Los Gatos",
        state: "CA",
        country: "USA",
        coordinates: [-121.9618, 37.2358] as [number, number],
        rating: 4.4,
        salaryRange: { min: 140000, max: 350000 },
        roles: [
          { title: "Software Engineer", count: 28, salaryRange: { min: 160000, max: 320000 } },
          { title: "Data Scientist", count: 20, salaryRange: { min: 150000, max: 300000 } },
          { title: "ML Engineer", count: 12, salaryRange: { min: 170000, max: 350000 } }
        ]
      }
    ]
  },
  {
    id: "5",
    name: "Apple",
    industry: "Technology",
    description: "Technology company that designs, manufactures, and markets smartphones, computers, and consumer electronics.",
    size: "Large (10,000+ employees)",
    globalRating: 4.6,
    website: "https://apple.com",
    foundedYear: 1976,
    tags: ["iOS", "Swift", "Objective-C", "Hardware", "Design", "AI"],
    locations: [
      {
        id: "apple-cupertino",
        city: "Cupertino",
        state: "CA",
        country: "USA",
        coordinates: [-122.0322, 37.3230] as [number, number],
        rating: 4.7,
        salaryRange: { min: 150000, max: 350000 },
        roles: [
          { title: "iOS Developer", count: 40, salaryRange: { min: 160000, max: 320000 } },
          { title: "Hardware Engineer", count: 35, salaryRange: { min: 150000, max: 300000 } },
          { title: "Machine Learning Engineer", count: 25, salaryRange: { min: 180000, max: 350000 } }
        ]
      }
    ]
  },
  {
    id: "6",
    name: "Amazon",
    industry: "E-commerce",
    description: "Multinational technology company focusing on e-commerce, cloud computing, and artificial intelligence.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://amazon.com",
    foundedYear: 1994,
    tags: ["AWS", "Java", "Python", "React", "Machine Learning", "Microservices"],
    locations: [
      {
        id: "amazon-seattle",
        city: "Seattle",
        state: "WA",
        country: "USA",
        coordinates: [-122.3321, 47.6062] as [number, number],
        rating: 4.1,
        salaryRange: { min: 130000, max: 300000 },
        roles: [
          { title: "Software Engineer", count: 50, salaryRange: { min: 140000, max: 280000 } },
          { title: "Cloud Engineer", count: 30, salaryRange: { min: 135000, max: 270000 } },
          { title: "Product Manager", count: 25, salaryRange: { min: 150000, max: 300000 } }
        ]
      },
      {
        id: "amazon-dublin",
        city: "Dublin",
        state: "",
        country: "Ireland",
        coordinates: [-6.2603, 53.3498] as [number, number],
        rating: 4.0,
        salaryRange: { min: 70000, max: 160000 },
        roles: [
          { title: "Software Engineer", count: 35, salaryRange: { min: 75000, max: 140000 } },
          { title: "DevOps Engineer", count: 20, salaryRange: { min: 70000, max: 130000 } }
        ]
      }
    ]
  },
  {
    id: "7",
    name: "Spotify",
    industry: "Entertainment",
    description: "Audio streaming and media services provider with millions of tracks and podcasts.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.4,
    website: "https://spotify.com",
    foundedYear: 2006,
    tags: ["Scala", "Python", "React", "Kubernetes", "BigQuery", "Machine Learning"],
    locations: [
      {
        id: "spotify-stockholm",
        city: "Stockholm",
        state: "",
        country: "Sweden",
        coordinates: [18.0686, 59.3293] as [number, number],
        rating: 4.5,
        salaryRange: { min: 60000, max: 140000 },
        roles: [
          { title: "Backend Engineer", count: 25, salaryRange: { min: 70000, max: 130000 } },
          { title: "Data Engineer", count: 15, salaryRange: { min: 65000, max: 125000 } },
          { title: "Mobile Developer", count: 18, salaryRange: { min: 60000, max: 120000 } }
        ]
      },
      {
        id: "spotify-nyc",
        city: "New York",
        state: "NY",
        country: "USA",
        coordinates: [-74.0060, 40.7128] as [number, number],
        rating: 4.3,
        salaryRange: { min: 120000, max: 250000 },
        roles: [
          { title: "Software Engineer", count: 20, salaryRange: { min: 130000, max: 230000 } },
          { title: "Product Manager", count: 12, salaryRange: { min: 140000, max: 250000 } }
        ]
      }
    ]
  },
  {
    id: "8",
    name: "Stripe",
    industry: "Finance",
    description: "Financial services and software company that allows businesses to accept payments over the internet.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.5,
    website: "https://stripe.com",
    foundedYear: 2010,
    tags: ["Ruby", "JavaScript", "Go", "Scala", "Payments", "API"],
    locations: [
      {
        id: "stripe-sf",
        city: "San Francisco",
        state: "CA",
        country: "USA",
        coordinates: [-122.4194, 37.7749] as [number, number],
        rating: 4.6,
        salaryRange: { min: 150000, max: 350000 },
        roles: [
          { title: "Software Engineer", count: 30, salaryRange: { min: 160000, max: 320000 } },
          { title: "Backend Engineer", count: 25, salaryRange: { min: 155000, max: 310000 } },
          { title: "Infrastructure Engineer", count: 15, salaryRange: { min: 165000, max: 330000 } }
        ]
      },
      {
        id: "stripe-dublin",
        city: "Dublin",
        state: "",
        country: "Ireland",
        coordinates: [-6.2603, 53.3498] as [number, number],
        rating: 4.4,
        salaryRange: { min: 80000, max: 180000 },
        roles: [
          { title: "Software Engineer", count: 22, salaryRange: { min: 85000, max: 160000 } },
          { title: "Payment Engineer", count: 18, salaryRange: { min: 80000, max: 150000 } }
        ]
      }
    ]
  },
  {
    id: "9",
    name: "Uber",
    industry: "Transportation",
    description: "Technology platform where we develop and operate proprietary technology applications.",
    size: "Large (10,000+ employees)",
    globalRating: 3.9,
    website: "https://uber.com",
    foundedYear: 2009,
    tags: ["Go", "Python", "React", "Microservices", "Machine Learning", "Mobile"],
    locations: [
      {
        id: "uber-sf",
        city: "San Francisco",
        state: "CA",
        country: "USA",
        coordinates: [-122.4194, 37.7749] as [number, number],
        rating: 4.0,
        salaryRange: { min: 140000, max: 320000 },
        roles: [
          { title: "Software Engineer", count: 35, salaryRange: { min: 150000, max: 300000 } },
          { title: "Data Scientist", count: 20, salaryRange: { min: 145000, max: 280000 } },
          { title: "Mobile Engineer", count: 25, salaryRange: { min: 140000, max: 270000 } }
        ]
      },
      {
        id: "uber-amsterdam",
        city: "Amsterdam",
        state: "",
        country: "Netherlands",
        coordinates: [4.9041, 52.3676] as [number, number],
        rating: 3.8,
        salaryRange: { min: 70000, max: 150000 },
        roles: [
          { title: "Software Engineer", count: 18, salaryRange: { min: 75000, max: 140000 } },
          { title: "Backend Engineer", count: 15, salaryRange: { min: 70000, max: 135000 } }
        ]
      }
    ]
  },
  {
    id: "10",
    name: "Airbnb",
    industry: "Travel",
    description: "Online marketplace for short-term homestays and experiences in various countries and regions.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.2,
    website: "https://airbnb.com",
    foundedYear: 2008,
    tags: ["Ruby", "JavaScript", "React", "Scala", "Machine Learning", "Mobile"],
    locations: [
      {
        id: "airbnb-sf",
        city: "San Francisco",
        state: "CA",
        country: "USA",
        coordinates: [-122.4194, 37.7749] as [number, number],
        rating: 4.3,
        salaryRange: { min: 140000, max: 310000 },
        roles: [
          { title: "Software Engineer", count: 28, salaryRange: { min: 150000, max: 290000 } },
          { title: "Product Manager", count: 15, salaryRange: { min: 160000, max: 310000 } },
          { title: "Data Engineer", count: 20, salaryRange: { min: 145000, max: 280000 } }
        ]
      }
    ]
  },
  {
    id: "11",
    name: "Tesla",
    industry: "Automotive",
    description: "Electric vehicle and clean energy company designing and manufacturing electric cars and energy storage systems.",
    size: "Large (10,000+ employees)",
    globalRating: 3.7,
    website: "https://tesla.com",
    foundedYear: 2003,
    tags: ["Python", "C++", "Embedded Systems", "Machine Learning", "Automotive", "AI"],
    locations: [
      {
        id: "tesla-fremont",
        city: "Fremont",
        state: "CA",
        country: "USA",
        coordinates: [-121.9886, 37.5485] as [number, number],
        rating: 3.8,
        salaryRange: { min: 120000, max: 280000 },
        roles: [
          { title: "Software Engineer", count: 40, salaryRange: { min: 130000, max: 260000 } },
          { title: "Embedded Engineer", count: 30, salaryRange: { min: 125000, max: 250000 } },
          { title: "AI Engineer", count: 25, salaryRange: { min: 140000, max: 280000 } }
        ]
      },
      {
        id: "tesla-berlin",
        city: "Berlin",
        state: "",
        country: "Germany",
        coordinates: [13.4050, 52.5200] as [number, number],
        rating: 3.6,
        salaryRange: { min: 70000, max: 160000 },
        roles: [
          { title: "Software Engineer", count: 25, salaryRange: { min: 75000, max: 150000 } },
          { title: "Manufacturing Engineer", count: 20, salaryRange: { min: 70000, max: 140000 } }
        ]
      }
    ]
  },
  {
    id: "12",
    name: "CD Projekt",
    industry: "Gaming",
    description: "Polish video game developer and publisher, creator of The Witcher and Cyberpunk 2077.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.2,
    website: "https://cdprojekt.com",
    foundedYear: 1994,
    tags: ["C++", "REDengine", "Game Development", "Unity", "Unreal Engine", "Python"],
    locations: [
      {
        id: "cdprojekt-warsaw",
        city: "Warsaw",
        state: "",
        country: "Poland",
        coordinates: [21.0122, 52.2297] as [number, number],
        rating: 4.3,
        salaryRange: { min: 35000, max: 80000 },
        roles: [
          { title: "Game Developer", count: 45, salaryRange: { min: 40000, max: 75000 } },
          { title: "3D Artist", count: 25, salaryRange: { min: 35000, max: 65000 } },
          { title: "Game Designer", count: 18, salaryRange: { min: 38000, max: 70000 } }
        ]
      },
      {
        id: "cdprojekt-krakow",
        city: "Krakow",
        state: "",
        country: "Poland",
        coordinates: [19.9449, 50.0647] as [number, number],
        rating: 4.1,
        salaryRange: { min: 32000, max: 75000 },
        roles: [
          { title: "Software Engineer", count: 20, salaryRange: { min: 35000, max: 70000 } },
          { title: "QA Engineer", count: 15, salaryRange: { min: 32000, max: 55000 } }
        ]
      }
    ]
  },
  {
    id: "13",
    name: "Avast",
    industry: "Cybersecurity",
    description: "Czech multinational cybersecurity software company providing antivirus software and internet security services.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://avast.com",
    foundedYear: 1988,
    tags: ["C++", "Python", "Machine Learning", "Cybersecurity", "Cloud Security", "Mobile Security"],
    locations: [
      {
        id: "avast-prague",
        city: "Prague",
        state: "",
        country: "Czech Republic",
        coordinates: [14.4378, 50.0755] as [number, number],
        rating: 4.1,
        salaryRange: { min: 45000, max: 95000 },
        roles: [
          { title: "Security Engineer", count: 35, salaryRange: { min: 50000, max: 90000 } },
          { title: "Malware Researcher", count: 20, salaryRange: { min: 55000, max: 95000 } },
          { title: "Software Engineer", count: 40, salaryRange: { min: 45000, max: 85000 } }
        ]
      },
      {
        id: "avast-brno",
        city: "Brno",
        state: "",
        country: "Czech Republic",
        coordinates: [16.6068, 49.1951] as [number, number],
        rating: 3.9,
        salaryRange: { min: 42000, max: 85000 },
        roles: [
          { title: "Mobile Security Engineer", count: 15, salaryRange: { min: 48000, max: 80000 } },
          { title: "Backend Developer", count: 22, salaryRange: { min: 42000, max: 75000 } }
        ]
      }
    ]
  },
  {
    id: "14",
    name: "UiPath",
    industry: "Robotic Process Automation",
    description: "Romanian-American multinational company that develops robotic process automation and artificial intelligence software.",
    size: "Large (10,000+ employees)",
    globalRating: 4.4,
    website: "https://uipath.com",
    foundedYear: 2005,
    tags: [".NET", "C#", "RPA", "AI", "Machine Learning", "Automation"],
    locations: [
      {
        id: "uipath-bucharest",
        city: "Bucharest",
        state: "",
        country: "Romania",
        coordinates: [26.1025, 44.4268] as [number, number],
        rating: 4.5,
        salaryRange: { min: 55000, max: 120000 },
        roles: [
          { title: "RPA Developer", count: 50, salaryRange: { min: 60000, max: 110000 } },
          { title: "AI Engineer", count: 30, salaryRange: { min: 65000, max: 120000 } },
          { title: "Software Engineer", count: 45, salaryRange: { min: 55000, max: 100000 } }
        ]
      },
      {
        id: "uipath-cluj",
        city: "Cluj-Napoca",
        state: "",
        country: "Romania",
        coordinates: [23.6236, 46.7712] as [number, number],
        rating: 4.3,
        salaryRange: { min: 50000, max: 110000 },
        roles: [
          { title: "Software Developer", count: 25, salaryRange: { min: 52000, max: 95000 } },
          { title: "Product Manager", count: 12, salaryRange: { min: 60000, max: 110000 } }
        ]
      }
    ]
  },
  {
    id: "15",
    name: "EPAM Systems",
    industry: "Software Development",
    description: "Multinational software engineering and IT consulting company with significant presence in Eastern Europe.",
    size: "Large (10,000+ employees)",
    globalRating: 4.1,
    website: "https://epam.com",
    foundedYear: 1993,
    tags: ["Java", "JavaScript", "Python", "React", "Angular", "Cloud", "DevOps"],
    locations: [
      {
        id: "epam-budapest",
        city: "Budapest",
        state: "",
        country: "Hungary",
        coordinates: [19.0402, 47.4979] as [number, number],
        rating: 4.2,
        salaryRange: { min: 45000, max: 85000 },
        roles: [
          { title: "Java Developer", count: 35, salaryRange: { min: 48000, max: 80000 } },
          { title: "Frontend Developer", count: 25, salaryRange: { min: 45000, max: 75000 } },
          { title: "DevOps Engineer", count: 20, salaryRange: { min: 50000, max: 85000 } }
        ]
      },
      {
        id: "epam-krakow",
        city: "Krakow",
        state: "",
        country: "Poland",
        coordinates: [19.9449, 50.0647] as [number, number],
        rating: 4.0,
        salaryRange: { min: 42000, max: 80000 },
        roles: [
          { title: "Software Engineer", count: 40, salaryRange: { min: 45000, max: 75000 } },
          { title: "QA Engineer", count: 18, salaryRange: { min: 42000, max: 65000 } }
        ]
      }
    ]
  },
  {
    id: "16",
    name: "ESET",
    industry: "Cybersecurity",
    description: "Slovak internet security company that develops antivirus and firewall products for businesses and consumers.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.3,
    website: "https://eset.com",
    foundedYear: 1992,
    tags: ["C++", "Assembly", "Cybersecurity", "Malware Analysis", "Network Security", "Endpoint Protection"],
    locations: [
      {
        id: "eset-bratislava",
        city: "Bratislava",
        state: "",
        country: "Slovakia",
        coordinates: [17.1077, 48.1482] as [number, number],
        rating: 4.4,
        salaryRange: { min: 48000, max: 90000 },
        roles: [
          { title: "Malware Analyst", count: 20, salaryRange: { min: 55000, max: 85000 } },
          { title: "Security Research Engineer", count: 15, salaryRange: { min: 60000, max: 90000 } },
          { title: "Software Developer", count: 25, salaryRange: { min: 48000, max: 80000 } }
        ]
      }
    ]
  },
  {
    id: "17",
    name: "Wise",
    industry: "Fintech",
    description: "Estonian financial technology company providing international money transfer services.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.5,
    website: "https://wise.com",
    foundedYear: 2011,
    tags: ["Java", "Python", "React", "Microservices", "AWS", "Fintech", "Payments"],
    locations: [
      {
        id: "wise-tallinn",
        city: "Tallinn",
        state: "",
        country: "Estonia",
        coordinates: [24.7536, 59.4370] as [number, number],
        rating: 4.6,
        salaryRange: { min: 65000, max: 120000 },
        roles: [
          { title: "Backend Engineer", count: 30, salaryRange: { min: 70000, max: 115000 } },
          { title: "Frontend Engineer", count: 25, salaryRange: { min: 65000, max: 105000 } },
          { title: "DevOps Engineer", count: 15, salaryRange: { min: 75000, max: 120000 } }
        ]
      }
    ]
  },
  {
    id: "18",
    name: "Outfit7",
    industry: "Mobile Gaming",
    description: "Slovenian mobile app developer best known for the Talking Tom and Friends series of games.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.2,
    website: "https://outfit7.com",
    foundedYear: 2009,
    tags: ["Unity", "C#", "Mobile Development", "Game Development", "iOS", "Android"],
    locations: [
      {
        id: "outfit7-ljubljana",
        city: "Ljubljana",
        state: "",
        country: "Slovenia",
        coordinates: [14.5058, 46.0569] as [number, number],
        rating: 4.3,
        salaryRange: { min: 50000, max: 95000 },
        roles: [
          { title: "Mobile Game Developer", count: 40, salaryRange: { min: 55000, max: 90000 } },
          { title: "Game Designer", count: 20, salaryRange: { min: 50000, max: 80000 } },
          { title: "3D Artist", count: 25, salaryRange: { min: 52000, max: 85000 } }
        ]
      }
    ]
  },
  {
    id: "19",
    name: "Infobip",
    industry: "Communications",
    description: "Croatian cloud communications platform that enables businesses to build connected experiences across all stages of the customer journey.",
    size: "Large (10,000+ employees)",
    globalRating: 4.1,
    website: "https://infobip.com",
    foundedYear: 2006,
    tags: ["Java", "Python", "Microservices", "Cloud", "Communications API", "Messaging"],
    locations: [
      {
        id: "infobip-zagreb",
        city: "Zagreb",
        state: "",
        country: "Croatia",
        coordinates: [15.9819, 45.8150] as [number, number],
        rating: 4.2,
        salaryRange: { min: 45000, max: 85000 },
        roles: [
          { title: "Backend Developer", count: 35, salaryRange: { min: 50000, max: 80000 } },
          { title: "Cloud Engineer", count: 20, salaryRange: { min: 52000, max: 85000 } },
          { title: "Software Engineer", count: 30, salaryRange: { min: 45000, max: 75000 } }
        ]
      }
    ]
  },
  {
    id: "20",
    name: "Bolt",
    industry: "Transportation",
    description: "Estonian mobility company that offers ride-hailing, micromobility rental, food and grocery delivery services.",
    size: "Large (10,000+ employees)",
    globalRating: 3.9,
    website: "https://bolt.eu",
    foundedYear: 2013,
    tags: ["Go", "Python", "React", "Microservices", "Machine Learning", "Mobile"],
    locations: [
      {
        id: "bolt-tallinn",
        city: "Tallinn",
        state: "",
        country: "Estonia",
        coordinates: [24.7536, 59.4370] as [number, number],
        rating: 4.0,
        salaryRange: { min: 55000, max: 100000 },
        roles: [
          { title: "Backend Engineer", count: 40, salaryRange: { min: 60000, max: 95000 } },
          { title: "Mobile Engineer", count: 25, salaryRange: { min: 58000, max: 90000 } },
          { title: "Data Scientist", count: 20, salaryRange: { min: 65000, max: 100000 } }
        ]
      }
    ]
  },
  // Czech Republic Companies (40 companies)
  {
    id: "21",
    name: "Škoda Auto",
    industry: "Automotive",
    description: "Czech automotive manufacturer producing cars for Volkswagen Group worldwide.",
    size: "Large (10,000+ employees)",
    globalRating: 4.2,
    website: "https://skoda.com",
    foundedYear: 1895,
    tags: ["Automotive Engineering", "Manufacturing", "Innovation", "Quality Management"],
    locations: [
      {
        id: "skoda-mladaboleslav",
        city: "Mladá Boleslav",
        state: "",
        country: "Czech Republic",
        coordinates: [14.9033, 50.4113] as [number, number],
        rating: 4.3,
        salaryRange: { min: 42000, max: 85000 },
        roles: [
          { title: "Automotive Engineer", count: 120, salaryRange: { min: 45000, max: 80000 } },
          { title: "Manufacturing Specialist", count: 80, salaryRange: { min: 42000, max: 70000 } },
          { title: "Quality Manager", count: 40, salaryRange: { min: 50000, max: 85000 } }
        ]
      }
    ]
  },
  {
    id: "22",
    name: "ČEZ Group",
    industry: "Energy",
    description: "Central European energy conglomerate and one of the largest power companies in Central and Southeastern Europe.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://cez.cz",
    foundedYear: 1992,
    tags: ["Energy", "Nuclear Power", "Renewable Energy", "Engineering"],
    locations: [
      {
        id: "cez-prague",
        city: "Prague",
        state: "",
        country: "Czech Republic",
        coordinates: [14.4378, 50.0755] as [number, number],
        rating: 4.1,
        salaryRange: { min: 48000, max: 90000 },
        roles: [
          { title: "Energy Engineer", count: 60, salaryRange: { min: 52000, max: 85000 } },
          { title: "Nuclear Specialist", count: 30, salaryRange: { min: 58000, max: 90000 } },
          { title: "Project Manager", count: 25, salaryRange: { min: 48000, max: 75000 } }
        ]
      }
    ]
  },
  {
    id: "23",
    name: "JetBrains",
    industry: "Software Development",
    description: "Czech software development company known for creating development tools like IntelliJ IDEA, PyCharm, and Kotlin.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.8,
    website: "https://jetbrains.com",
    foundedYear: 2000,
    tags: ["IDE Development", "Kotlin", "Software Tools", "Programming Languages"],
    locations: [
      {
        id: "jetbrains-prague",
        city: "Prague",
        state: "",
        country: "Czech Republic",
        coordinates: [14.4378, 50.0755] as [number, number],
        rating: 4.9,
        salaryRange: { min: 65000, max: 130000 },
        roles: [
          { title: "Software Engineer", count: 45, salaryRange: { min: 70000, max: 120000 } },
          { title: "IDE Developer", count: 25, salaryRange: { min: 75000, max: 130000 } },
          { title: "Language Designer", count: 15, salaryRange: { min: 80000, max: 125000 } }
        ]
      }
    ]
  },
  {
    id: "24",
    name: "Societe Generale",
    industry: "Banking",
    description: "French multinational banking and financial services company with significant operations in Czech Republic.",
    size: "Large (10,000+ employees)",
    globalRating: 3.9,
    website: "https://societegenerale.cz",
    foundedYear: 1864,
    tags: ["Banking", "Financial Services", "Investment", "Risk Management"],
    locations: [
      {
        id: "sg-prague",
        city: "Prague",
        state: "",
        country: "Czech Republic",
        coordinates: [14.4378, 50.0755] as [number, number],
        rating: 4.0,
        salaryRange: { min: 45000, max: 85000 },
        roles: [
          { title: "Financial Analyst", count: 35, salaryRange: { min: 48000, max: 75000 } },
          { title: "Risk Manager", count: 20, salaryRange: { min: 52000, max: 85000 } },
          { title: "Investment Advisor", count: 25, salaryRange: { min: 45000, max: 70000 } }
        ]
      }
    ]
  },
  {
    id: "25",
    name: "O2 Czech Republic",
    industry: "Telecommunications",
    description: "Leading telecommunications operator in Czech Republic providing mobile, internet and TV services.",
    size: "Large (10,000+ employees)",
    globalRating: 3.8,
    website: "https://o2.cz",
    foundedYear: 1996,
    tags: ["Telecommunications", "Mobile Networks", "Internet Services", "5G"],
    locations: [
      {
        id: "o2-prague",
        city: "Prague",
        state: "",
        country: "Czech Republic",
        coordinates: [14.4378, 50.0755] as [number, number],
        rating: 3.9,
        salaryRange: { min: 40000, max: 75000 },
        roles: [
          { title: "Network Engineer", count: 40, salaryRange: { min: 45000, max: 70000 } },
          { title: "Software Developer", count: 30, salaryRange: { min: 42000, max: 68000 } },
          { title: "Customer Experience Manager", count: 25, salaryRange: { min: 40000, max: 62000 } }
        ]
      }
    ]
  },
  {
    id: "26",
    name: "PPF Group",
    industry: "Financial Services",
    description: "Czech international investment group operating across multiple sectors including banking, telecommunications, and real estate.",
    size: "Large (10,000+ employees)",
    globalRating: 4.1,
    website: "https://ppf.eu",
    foundedYear: 1991,
    tags: ["Investment", "Banking", "Private Equity", "Real Estate"],
    locations: [
      {
        id: "ppf-prague",
        city: "Prague",
        state: "",
        country: "Czech Republic",
        coordinates: [14.4378, 50.0755] as [number, number],
        rating: 4.2,
        salaryRange: { min: 55000, max: 95000 },
        roles: [
          { title: "Investment Analyst", count: 25, salaryRange: { min: 60000, max: 90000 } },
          { title: "Portfolio Manager", count: 15, salaryRange: { min: 65000, max: 95000 } },
          { title: "Financial Controller", count: 20, salaryRange: { min: 55000, max: 80000 } }
        ]
      }
    ]
  },
  {
    id: "27",
    name: "Bohemia Interactive",
    industry: "Gaming",
    description: "Czech video game developer known for military simulation games like ARMA series and DayZ.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.4,
    website: "https://bohemia.net",
    foundedYear: 1999,
    tags: ["Game Development", "Military Simulation", "C++", "Game Engine"],
    locations: [
      {
        id: "bohemia-prague",
        city: "Prague",
        state: "",
        country: "Czech Republic",
        coordinates: [14.4378, 50.0755] as [number, number],
        rating: 4.5,
        salaryRange: { min: 48000, max: 85000 },
        roles: [
          { title: "Game Developer", count: 35, salaryRange: { min: 52000, max: 80000 } },
          { title: "3D Artist", count: 25, salaryRange: { min: 48000, max: 75000 } },
          { title: "Game Designer", count: 20, salaryRange: { min: 50000, max: 78000 } }
        ]
      }
    ]
  },
  {
    id: "28",
    name: "Erste Bank",
    industry: "Banking",
    description: "Austrian banking group with significant presence in Czech Republic providing retail and corporate banking services.",
    size: "Large (10,000+ employees)",
    globalRating: 3.9,
    website: "https://erstebank.cz",
    foundedYear: 1819,
    tags: ["Retail Banking", "Corporate Banking", "Digital Banking", "Financial Services"],
    locations: [
      {
        id: "erste-prague",
        city: "Prague",
        state: "",
        country: "Czech Republic",
        coordinates: [14.4378, 50.0755] as [number, number],
        rating: 4.0,
        salaryRange: { min: 42000, max: 75000 },
        roles: [
          { title: "Banking Specialist", count: 45, salaryRange: { min: 45000, max: 70000 } },
          { title: "Digital Banking Developer", count: 25, salaryRange: { min: 48000, max: 75000 } },
          { title: "Credit Analyst", count: 20, salaryRange: { min: 42000, max: 65000 } }
        ]
      }
    ]
  },
  {
    id: "29",
    name: "T-Mobile Czech Republic",
    industry: "Telecommunications",
    description: "Leading mobile network operator in Czech Republic, part of Deutsche Telekom group.",
    size: "Large (10,000+ employees)",
    globalRating: 3.8,
    website: "https://t-mobile.cz",
    foundedYear: 1996,
    tags: ["Mobile Networks", "5G Technology", "Customer Service", "Digital Services"],
    locations: [
      {
        id: "tmobile-prague",
        city: "Prague",
        state: "",
        country: "Czech Republic",
        coordinates: [14.4378, 50.0755] as [number, number],
        rating: 3.9,
        salaryRange: { min: 38000, max: 70000 },
        roles: [
          { title: "Network Technician", count: 50, salaryRange: { min: 40000, max: 65000 } },
          { title: "Software Developer", count: 30, salaryRange: { min: 45000, max: 70000 } },
          { title: "Customer Service Manager", count: 25, salaryRange: { min: 38000, max: 58000 } }
        ]
      }
    ]
  },
  {
    id: "30",
    name: "Zentiva",
    industry: "Pharmaceuticals",
    description: "Pharmaceutical company focusing on generic medicines and healthcare solutions across Central and Eastern Europe.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://zentiva.com",
    foundedYear: 1969,
    tags: ["Pharmaceuticals", "Generic Medicines", "Healthcare", "Research"],
    locations: [
      {
        id: "zentiva-prague",
        city: "Prague",
        state: "",
        country: "Czech Republic",
        coordinates: [14.4378, 50.0755] as [number, number],
        rating: 4.1,
        salaryRange: { min: 45000, max: 80000 },
        roles: [
          { title: "Pharmaceutical Researcher", count: 30, salaryRange: { min: 50000, max: 75000 } },
          { title: "Quality Assurance Specialist", count: 25, salaryRange: { min: 45000, max: 65000 } },
          { title: "Regulatory Affairs Manager", count: 15, salaryRange: { min: 55000, max: 80000 } }
        ]
      }
    ]
  },
  // Austria Companies (40 companies)  
  {
    id: "31",
    name: "OMV",
    industry: "Oil & Gas",
    description: "Austrian integrated oil and gas company with operations in upstream, downstream and chemical businesses.",
    size: "Large (10,000+ employees)",
    globalRating: 4.1,
    website: "https://omv.com",
    foundedYear: 1956,
    tags: ["Oil & Gas", "Petrochemicals", "Energy", "Sustainability"],
    locations: [
      {
        id: "omv-vienna",
        city: "Vienna",
        state: "",
        country: "Austria",
        coordinates: [16.3738, 48.2082] as [number, number],
        rating: 4.2,
        salaryRange: { min: 55000, max: 105000 },
        roles: [
          { title: "Petroleum Engineer", count: 45, salaryRange: { min: 60000, max: 95000 } },
          { title: "Chemical Engineer", count: 35, salaryRange: { min: 58000, max: 90000 } },
          { title: "Project Manager", count: 30, salaryRange: { min: 55000, max: 85000 } }
        ]
      }
    ]
  },
  {
    id: "32",
    name: "Erste Group Bank",
    industry: "Banking",
    description: "One of the largest financial services providers in Central and Eastern Europe, headquartered in Vienna.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://erstegroup.com",
    foundedYear: 1819,
    tags: ["Banking", "Financial Services", "Digital Banking", "Investment"],
    locations: [
      {
        id: "erste-vienna",
        city: "Vienna",
        state: "",
        country: "Austria",
        coordinates: [16.3738, 48.2082] as [number, number],
        rating: 4.1,
        salaryRange: { min: 50000, max: 95000 },
        roles: [
          { title: "Investment Banker", count: 40, salaryRange: { min: 60000, max: 95000 } },
          { title: "Risk Analyst", count: 35, salaryRange: { min: 52000, max: 80000 } },
          { title: "Digital Banking Specialist", count: 30, salaryRange: { min: 50000, max: 75000 } }
        ]
      }
    ]
  },
  {
    id: "33",
    name: "Red Bull",
    industry: "Consumer Goods",
    description: "Austrian multinational company known for energy drinks, sports marketing, and media properties.",
    size: "Large (10,000+ employees)",
    globalRating: 4.5,
    website: "https://redbull.com",
    foundedYear: 1987,
    tags: ["Consumer Goods", "Marketing", "Sports", "Media"],
    locations: [
      {
        id: "redbull-salzburg",
        city: "Salzburg",
        state: "",
        country: "Austria",
        coordinates: [13.0550, 47.8095] as [number, number],
        rating: 4.6,
        salaryRange: { min: 55000, max: 100000 },
        roles: [
          { title: "Brand Manager", count: 35, salaryRange: { min: 60000, max: 90000 } },
          { title: "Marketing Specialist", count: 40, salaryRange: { min: 55000, max: 85000 } },
          { title: "Content Creator", count: 25, salaryRange: { min: 52000, max: 78000 } }
        ]
      }
    ]
  },
  {
    id: "34",
    name: "Andritz",
    industry: "Industrial Technology",
    description: "Austrian technology group providing plants, equipment, and services for various industries.",
    size: "Large (10,000+ employees)",
    globalRating: 4.2,
    website: "https://andritz.com",
    foundedYear: 1852,
    tags: ["Industrial Engineering", "Manufacturing", "Technology", "Automation"],
    locations: [
      {
        id: "andritz-graz",
        city: "Graz",
        state: "",
        country: "Austria",
        coordinates: [15.4395, 47.0707] as [number, number],
        rating: 4.3,
        salaryRange: { min: 52000, max: 90000 },
        roles: [
          { title: "Mechanical Engineer", count: 50, salaryRange: { min: 55000, max: 85000 } },
          { title: "Project Engineer", count: 40, salaryRange: { min: 52000, max: 80000 } },
          { title: "Automation Specialist", count: 25, salaryRange: { min: 58000, max: 90000 } }
        ]
      }
    ]
  },
  {
    id: "35",
    name: "Voestalpine",
    industry: "Steel & Technology",
    description: "Austrian steel-based technology and capital goods group with worldwide operations.",
    size: "Large (10,000+ employees)",
    globalRating: 4.1,
    website: "https://voestalpine.com",
    foundedYear: 1938,
    tags: ["Steel Production", "Technology", "Automotive", "Railway Systems"],
    locations: [
      {
        id: "voestalpine-linz",
        city: "Linz",
        state: "",
        country: "Austria",
        coordinates: [14.2858, 48.3069] as [number, number],
        rating: 4.2,
        salaryRange: { min: 48000, max: 85000 },
        roles: [
          { title: "Metallurgical Engineer", count: 45, salaryRange: { min: 52000, max: 80000 } },
          { title: "Production Manager", count: 35, salaryRange: { min: 55000, max: 85000 } },
          { title: "Quality Engineer", count: 30, salaryRange: { min: 48000, max: 75000 } }
        ]
      }
    ]
  },
  {
    id: "36",
    name: "A1 Telekom Austria",
    industry: "Telecommunications",
    description: "Leading telecommunications provider in Austria offering mobile, internet, and digital services.",
    size: "Large (10,000+ employees)",
    globalRating: 3.9,
    website: "https://a1.net",
    foundedYear: 1881,
    tags: ["Telecommunications", "5G", "Digital Services", "Internet"],
    locations: [
      {
        id: "a1-vienna",
        city: "Vienna",
        state: "",
        country: "Austria",
        coordinates: [16.3738, 48.2082] as [number, number],
        rating: 4.0,
        salaryRange: { min: 45000, max: 80000 },
        roles: [
          { title: "Network Engineer", count: 50, salaryRange: { min: 48000, max: 75000 } },
          { title: "Software Developer", count: 40, salaryRange: { min: 50000, max: 80000 } },
          { title: "Customer Solutions Manager", count: 30, salaryRange: { min: 45000, max: 70000 } }
        ]
      }
    ]
  },
  {
    id: "37",
    name: "Raiffeisen Bank International",
    industry: "Banking",
    description: "Leading commercial and investment bank in Central and Eastern Europe with headquarters in Vienna.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://rbinternational.com",
    foundedYear: 1927,
    tags: ["Banking", "Investment", "Corporate Banking", "Digital Finance"],
    locations: [
      {
        id: "rbi-vienna",
        city: "Vienna",
        state: "",
        country: "Austria",
        coordinates: [16.3738, 48.2082] as [number, number],
        rating: 4.1,
        salaryRange: { min: 52000, max: 95000 },
        roles: [
          { title: "Corporate Banker", count: 40, salaryRange: { min: 58000, max: 90000 } },
          { title: "Investment Analyst", count: 30, salaryRange: { min: 55000, max: 85000 } },
          { title: "Risk Manager", count: 25, salaryRange: { min: 52000, max: 80000 } }
        ]
      }
    ]
  },
  {
    id: "38",
    name: "Austrian Airlines",
    industry: "Aviation",
    description: "Flag carrier of Austria and member of the Lufthansa Group, providing passenger and cargo services.",
    size: "Large (10,000+ employees)",
    globalRating: 3.8,
    website: "https://austrian.com",
    foundedYear: 1957,
    tags: ["Aviation", "Customer Service", "Operations", "Logistics"],
    locations: [
      {
        id: "austrian-vienna",
        city: "Vienna",
        state: "",
        country: "Austria",
        coordinates: [16.3738, 48.2082] as [number, number],
        rating: 3.9,
        salaryRange: { min: 42000, max: 75000 },
        roles: [
          { title: "Flight Operations Specialist", count: 45, salaryRange: { min: 48000, max: 70000 } },
          { title: "Aircraft Maintenance Engineer", count: 40, salaryRange: { min: 45000, max: 75000 } },
          { title: "Customer Service Manager", count: 35, salaryRange: { min: 42000, max: 65000 } }
        ]
      }
    ]
  },
  {
    id: "39",
    name: "Kapsch TrafficCom",
    industry: "Technology",
    description: "Austrian technology company providing intelligent transportation systems and traffic management solutions.",
    size: "Large (10,000+ employees)",
    globalRating: 4.1,
    website: "https://kapsch.net",
    foundedYear: 1892,
    tags: ["ITS", "Traffic Management", "Smart Cities", "Technology"],
    locations: [
      {
        id: "kapsch-vienna",
        city: "Vienna",
        state: "",
        country: "Austria",
        coordinates: [16.3738, 48.2082] as [number, number],
        rating: 4.2,
        salaryRange: { min: 52000, max: 88000 },
        roles: [
          { title: "Software Engineer", count: 40, salaryRange: { min: 55000, max: 85000 } },
          { title: "Systems Engineer", count: 35, salaryRange: { min: 52000, max: 80000 } },
          { title: "Project Manager", count: 25, salaryRange: { min: 58000, max: 88000 } }
        ]
      }
    ]
  },
  {
    id: "40",
    name: "Borealis",
    industry: "Chemicals",
    description: "Leading provider of advanced and circular polyolefin solutions and European market leader in base chemicals.",
    size: "Large (10,000+ employees)",
    globalRating: 4.2,
    website: "https://borealisgroup.com",
    foundedYear: 1994,
    tags: ["Chemicals", "Polymers", "Sustainability", "Innovation"],
    locations: [
      {
        id: "borealis-vienna",
        city: "Vienna",
        state: "",
        country: "Austria",
        coordinates: [16.3738, 48.2082] as [number, number],
        rating: 4.3,
        salaryRange: { min: 55000, max: 95000 },
        roles: [
          { title: "Chemical Engineer", count: 40, salaryRange: { min: 60000, max: 90000 } },
          { title: "Process Engineer", count: 35, salaryRange: { min: 58000, max: 85000 } },
          { title: "R&D Specialist", count: 25, salaryRange: { min: 62000, max: 95000 } }
        ]
      }
    ]
  },
  // Germany Companies (40 companies)
  {
    id: "41",
    name: "Siemens",
    industry: "Technology",
    description: "German multinational conglomerate focusing on industry, energy, healthcare and infrastructure solutions.",
    size: "Large (10,000+ employees)",
    globalRating: 4.3,
    website: "https://siemens.com",
    foundedYear: 1847,
    tags: ["Industrial Automation", "Healthcare Technology", "Energy", "Software"],
    locations: [
      {
        id: "siemens-munich",
        city: "Munich",
        state: "",
        country: "Germany",
        coordinates: [11.5820, 48.1351] as [number, number],
        rating: 4.4,
        salaryRange: { min: 65000, max: 120000 },
        roles: [
          { title: "Software Engineer", count: 80, salaryRange: { min: 70000, max: 110000 } },
          { title: "Automation Engineer", count: 60, salaryRange: { min: 68000, max: 105000 } },
          { title: "Project Manager", count: 50, salaryRange: { min: 65000, max: 100000 } }
        ]
      },
      {
        id: "siemens-berlin",
        city: "Berlin",
        state: "",
        country: "Germany",
        coordinates: [13.4050, 52.5200] as [number, number],
        rating: 4.2,
        salaryRange: { min: 62000, max: 115000 },
        roles: [
          { title: "Research Engineer", count: 45, salaryRange: { min: 68000, max: 110000 } },
          { title: "System Architect", count: 30, salaryRange: { min: 75000, max: 115000 } }
        ]
      }
    ]
  },
  {
    id: "42",
    name: "BMW Group",
    industry: "Automotive",
    description: "German luxury vehicle manufacturer producing cars, motorcycles and automotive technology.",
    size: "Large (10,000+ employees)",
    globalRating: 4.4,
    website: "https://bmwgroup.com",
    foundedYear: 1916,
    tags: ["Automotive", "Luxury Vehicles", "Electric Mobility", "Innovation"],
    locations: [
      {
        id: "bmw-munich",
        city: "Munich",
        state: "",
        country: "Germany",
        coordinates: [11.5820, 48.1351] as [number, number],
        rating: 4.5,
        salaryRange: { min: 68000, max: 125000 },
        roles: [
          { title: "Automotive Engineer", count: 100, salaryRange: { min: 72000, max: 115000 } },
          { title: "Software Developer", count: 70, salaryRange: { min: 70000, max: 110000 } },
          { title: "Design Engineer", count: 50, salaryRange: { min: 68000, max: 105000 } }
        ]
      }
    ]
  },
  {
    id: "43",
    name: "Mercedes-Benz Group",
    industry: "Automotive",
    description: "German luxury automotive manufacturer known for premium vehicles and automotive innovation.",
    size: "Large (10,000+ employees)",
    globalRating: 4.3,
    website: "https://mercedes-benz.com",
    foundedYear: 1926,
    tags: ["Luxury Automobiles", "Innovation", "Electric Vehicles", "Autonomous Driving"],
    locations: [
      {
        id: "mercedes-stuttgart",
        city: "Stuttgart",
        state: "",
        country: "Germany",
        coordinates: [9.1829, 48.7758] as [number, number],
        rating: 4.4,
        salaryRange: { min: 70000, max: 130000 },
        roles: [
          { title: "Automotive Engineer", count: 120, salaryRange: { min: 75000, max: 120000 } },
          { title: "Autonomous Driving Engineer", count: 60, salaryRange: { min: 80000, max: 130000 } },
          { title: "Manufacturing Engineer", count: 80, salaryRange: { min: 70000, max: 110000 } }
        ]
      }
    ]
  },
  {
    id: "44",
    name: "Volkswagen Group",
    industry: "Automotive",
    description: "German automotive manufacturing group with multiple brands including VW, Audi, and Porsche.",
    size: "Large (10,000+ employees)",
    globalRating: 4.2,
    website: "https://volkswagen.com",
    foundedYear: 1937,
    tags: ["Automotive Manufacturing", "Electric Mobility", "Software", "Innovation"],
    locations: [
      {
        id: "vw-wolfsburg",
        city: "Wolfsburg",
        state: "",
        country: "Germany",
        coordinates: [10.7873, 52.4227] as [number, number],
        rating: 4.3,
        salaryRange: { min: 65000, max: 115000 },
        roles: [
          { title: "Software Engineer", count: 90, salaryRange: { min: 70000, max: 110000 } },
          { title: "Electric Vehicle Engineer", count: 70, salaryRange: { min: 72000, max: 115000 } },
          { title: "Production Manager", count: 60, salaryRange: { min: 65000, max: 100000 } }
        ]
      }
    ]
  },
  {
    id: "45",
    name: "Bosch",
    industry: "Technology",
    description: "German multinational engineering and technology company providing automotive and industrial technology.",
    size: "Large (10,000+ employees)",
    globalRating: 4.2,
    website: "https://bosch.com",
    foundedYear: 1886,
    tags: ["Automotive Technology", "IoT", "Industry 4.0", "Mobility Solutions"],
    locations: [
      {
        id: "bosch-stuttgart",
        city: "Stuttgart",
        state: "",
        country: "Germany",
        coordinates: [9.1829, 48.7758] as [number, number],
        rating: 4.3,
        salaryRange: { min: 62000, max: 110000 },
        roles: [
          { title: "Embedded Software Engineer", count: 80, salaryRange: { min: 68000, max: 105000 } },
          { title: "Automotive Systems Engineer", count: 70, salaryRange: { min: 65000, max: 100000 } },
          { title: "IoT Developer", count: 50, salaryRange: { min: 62000, max: 95000 } }
        ]
      }
    ]
  },
  {
    id: "46",
    name: "Deutsche Bank",
    industry: "Banking",
    description: "German multinational investment bank and financial services company.",
    size: "Large (10,000+ employees)",
    globalRating: 3.8,
    website: "https://deutschebank.com",
    foundedYear: 1870,
    tags: ["Investment Banking", "Financial Services", "Trading", "Asset Management"],
    locations: [
      {
        id: "db-frankfurt",
        city: "Frankfurt",
        state: "",
        country: "Germany",
        coordinates: [8.6821, 50.1109] as [number, number],
        rating: 3.9,
        salaryRange: { min: 65000, max: 130000 },
        roles: [
          { title: "Investment Banker", count: 60, salaryRange: { min: 80000, max: 130000 } },
          { title: "Quantitative Analyst", count: 40, salaryRange: { min: 75000, max: 120000 } },
          { title: "Risk Manager", count: 35, salaryRange: { min: 65000, max: 105000 } }
        ]
      }
    ]
  },
  {
    id: "47",
    name: "Allianz",
    industry: "Insurance",
    description: "German multinational financial services company and one of the world's largest insurance companies.",
    size: "Large (10,000+ employees)",
    globalRating: 4.1,
    website: "https://allianz.com",
    foundedYear: 1890,
    tags: ["Insurance", "Asset Management", "Financial Services", "Risk Management"],
    locations: [
      {
        id: "allianz-munich",
        city: "Munich",
        state: "",
        country: "Germany",
        coordinates: [11.5820, 48.1351] as [number, number],
        rating: 4.2,
        salaryRange: { min: 58000, max: 105000 },
        roles: [
          { title: "Actuary", count: 45, salaryRange: { min: 65000, max: 100000 } },
          { title: "Risk Analyst", count: 40, salaryRange: { min: 60000, max: 95000 } },
          { title: "Investment Manager", count: 30, salaryRange: { min: 70000, max: 105000 } }
        ]
      }
    ]
  },
  {
    id: "48",
    name: "Deutsche Telekom",
    industry: "Telecommunications",
    description: "German telecommunications company and Europe's largest telecommunications provider by revenue.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://telekom.com",
    foundedYear: 1995,
    tags: ["Telecommunications", "5G", "Cloud Services", "Digital Transformation"],
    locations: [
      {
        id: "telekom-bonn",
        city: "Bonn",
        state: "",
        country: "Germany",
        coordinates: [7.0982, 50.7374] as [number, number],
        rating: 4.1,
        salaryRange: { min: 55000, max: 95000 },
        roles: [
          { title: "Network Engineer", count: 70, salaryRange: { min: 60000, max: 90000 } },
          { title: "Cloud Solutions Architect", count: 50, salaryRange: { min: 65000, max: 95000 } },
          { title: "5G Specialist", count: 40, salaryRange: { min: 62000, max: 92000 } }
        ]
      }
    ]
  },
  {
    id: "49",
    name: "BASF",
    industry: "Chemicals",
    description: "German multinational chemical company and the largest chemical producer in the world.",
    size: "Large (10,000+ employees)",
    globalRating: 4.1,
    website: "https://basf.com",
    foundedYear: 1865,
    tags: ["Chemicals", "Materials Science", "Sustainability", "Innovation"],
    locations: [
      {
        id: "basf-ludwigshafen",
        city: "Ludwigshafen",
        state: "",
        country: "Germany",
        coordinates: [8.4353, 49.4774] as [number, number],
        rating: 4.2,
        salaryRange: { min: 60000, max: 110000 },
        roles: [
          { title: "Chemical Engineer", count: 80, salaryRange: { min: 65000, max: 105000 } },
          { title: "Process Engineer", count: 60, salaryRange: { min: 62000, max: 100000 } },
          { title: "R&D Scientist", count: 50, salaryRange: { min: 68000, max: 110000 } }
        ]
      }
    ]
  },
  {
    id: "50",
    name: "Bayer",
    industry: "Pharmaceuticals",
    description: "German multinational pharmaceutical and biotechnology company with focus on healthcare and agriculture.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://bayer.com",
    foundedYear: 1863,
    tags: ["Pharmaceuticals", "Biotechnology", "Healthcare", "Agriculture"],
    locations: [
      {
        id: "bayer-leverkusen",
        city: "Leverkusen",
        state: "",
        country: "Germany",
        coordinates: [7.0003, 51.0347] as [number, number],
        rating: 4.1,
        salaryRange: { min: 62000, max: 115000 },
        roles: [
          { title: "Pharmaceutical Researcher", count: 60, salaryRange: { min: 70000, max: 110000 } },
          { title: "Biotech Engineer", count: 45, salaryRange: { min: 68000, max: 105000 } },
          { title: "Clinical Research Associate", count: 40, salaryRange: { min: 62000, max: 95000 } }
        ]
      }
    ]
  },
  {
    id: "51",
    name: "ThyssenKrupp",
    industry: "Industrial",
    description: "German multinational conglomerate with focus on industrial engineering and steel production.",
    size: "Large (10,000+ employees)",
    globalRating: 3.9,
    website: "https://thyssenkrupp.com",
    foundedYear: 1999,
    tags: ["Steel", "Industrial Engineering", "Elevator Technology", "Marine Systems"],
    locations: [
      {
        id: "thyssenkrupp-essen",
        city: "Essen",
        state: "",
        country: "Germany",
        coordinates: [7.0116, 51.4556] as [number, number],
        rating: 4.0,
        salaryRange: { min: 55000, max: 95000 },
        roles: [
          { title: "Industrial Engineer", count: 60, salaryRange: { min: 58000, max: 88000 } },
          { title: "Steel Production Manager", count: 40, salaryRange: { min: 60000, max: 95000 } },
          { title: "Mechanical Engineer", count: 50, salaryRange: { min: 55000, max: 85000 } }
        ]
      }
    ]
  },
  {
    id: "52",
    name: "Continental",
    industry: "Automotive",
    description: "German automotive manufacturing company specializing in tires, automotive parts, and electronics.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://continental.com",
    foundedYear: 1871,
    tags: ["Automotive Parts", "Tires", "Electronics", "Autonomous Driving"],
    locations: [
      {
        id: "continental-hanover",
        city: "Hanover",
        state: "",
        country: "Germany",
        coordinates: [9.7320, 52.3759] as [number, number],
        rating: 4.1,
        salaryRange: { min: 58000, max: 100000 },
        roles: [
          { title: "Automotive Engineer", count: 70, salaryRange: { min: 62000, max: 95000 } },
          { title: "Electronics Engineer", count: 50, salaryRange: { min: 60000, max: 90000 } },
          { title: "Software Developer", count: 45, salaryRange: { min: 58000, max: 88000 } }
        ]
      }
    ]
  },
  {
    id: "53",
    name: "Henkel",
    industry: "Consumer Goods",
    description: "German chemical and consumer goods company with leading brands in laundry, home care, and cosmetics.",
    size: "Large (10,000+ employees)",
    globalRating: 4.1,
    website: "https://henkel.com",
    foundedYear: 1876,
    tags: ["Consumer Goods", "Chemicals", "Adhesives", "Personal Care"],
    locations: [
      {
        id: "henkel-dusseldorf",
        city: "Düsseldorf",
        state: "",
        country: "Germany",
        coordinates: [6.7735, 51.2277] as [number, number],
        rating: 4.2,
        salaryRange: { min: 55000, max: 95000 },
        roles: [
          { title: "Product Manager", count: 40, salaryRange: { min: 60000, max: 90000 } },
          { title: "Chemical Engineer", count: 35, salaryRange: { min: 58000, max: 85000 } },
          { title: "Marketing Manager", count: 30, salaryRange: { min: 55000, max: 80000 } }
        ]
      }
    ]
  },
  {
    id: "54",
    name: "Adidas",
    industry: "Sportswear",
    description: "German multinational corporation that designs and manufactures shoes, clothing and accessories.",
    size: "Large (10,000+ employees)",
    globalRating: 4.2,
    website: "https://adidas.com",
    foundedYear: 1949,
    tags: ["Sportswear", "Footwear", "Design", "Marketing"],
    locations: [
      {
        id: "adidas-herzogenaurach",
        city: "Herzogenaurach",
        state: "",
        country: "Germany",
        coordinates: [10.9089, 49.5707] as [number, number],
        rating: 4.3,
        salaryRange: { min: 52000, max: 90000 },
        roles: [
          { title: "Product Designer", count: 45, salaryRange: { min: 55000, max: 85000 } },
          { title: "Brand Manager", count: 35, salaryRange: { min: 58000, max: 90000 } },
          { title: "Supply Chain Manager", count: 30, salaryRange: { min: 52000, max: 78000 } }
        ]
      }
    ]
  },
  {
    id: "55",
    name: "Puma",
    industry: "Sportswear",
    description: "German multinational corporation that designs and manufactures athletic and casual footwear, apparel and accessories.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://puma.com",
    foundedYear: 1948,
    tags: ["Sportswear", "Athletic Footwear", "Lifestyle", "Innovation"],
    locations: [
      {
        id: "puma-herzogenaurach",
        city: "Herzogenaurach",
        state: "",
        country: "Germany",
        coordinates: [10.9089, 49.5707] as [number, number],
        rating: 4.1,
        salaryRange: { min: 50000, max: 85000 },
        roles: [
          { title: "Product Developer", count: 40, salaryRange: { min: 53000, max: 80000 } },
          { title: "Digital Marketing Manager", count: 30, salaryRange: { min: 55000, max: 85000 } },
          { title: "Sports Marketing Specialist", count: 25, salaryRange: { min: 50000, max: 75000 } }
        ]
      }
    ]
  },
  {
    id: "56",
    name: "Lufthansa Group",
    industry: "Aviation",
    description: "German aviation group and one of the world's largest airline groups operating passenger and cargo services.",
    size: "Large (10,000+ employees)",
    globalRating: 3.8,
    website: "https://lufthansa.com",
    foundedYear: 1953,
    tags: ["Aviation", "Logistics", "Customer Service", "Operations"],
    locations: [
      {
        id: "lufthansa-frankfurt",
        city: "Frankfurt",
        state: "",
        country: "Germany",
        coordinates: [8.6821, 50.1109] as [number, number],
        rating: 3.9,
        salaryRange: { min: 48000, max: 85000 },
        roles: [
          { title: "Flight Operations Manager", count: 50, salaryRange: { min: 55000, max: 80000 } },
          { title: "Aircraft Maintenance Engineer", count: 60, salaryRange: { min: 50000, max: 85000 } },
          { title: "Customer Experience Manager", count: 40, salaryRange: { min: 48000, max: 75000 } }
        ]
      }
    ]
  },
  {
    id: "57",
    name: "TUI Group",
    industry: "Travel & Tourism",
    description: "German multinational travel and tourism company, one of the largest leisure, travel and tourism companies in the world.",
    size: "Large (10,000+ employees)",
    globalRating: 3.7,
    website: "https://tuigroup.com",
    foundedYear: 1968,
    tags: ["Travel", "Tourism", "Hospitality", "Digital Services"],
    locations: [
      {
        id: "tui-hanover",
        city: "Hanover",
        state: "",
        country: "Germany",
        coordinates: [9.7320, 52.3759] as [number, number],
        rating: 3.8,
        salaryRange: { min: 45000, max: 78000 },
        roles: [
          { title: "Travel Product Manager", count: 35, salaryRange: { min: 50000, max: 75000 } },
          { title: "Digital Marketing Specialist", count: 30, salaryRange: { min: 48000, max: 70000 } },
          { title: "Customer Service Manager", count: 40, salaryRange: { min: 45000, max: 65000 } }
        ]
      }
    ]
  },
  {
    id: "58",
    name: "KION Group",
    industry: "Industrial Technology",
    description: "German manufacturer of forklifts, warehouse technology and related services.",
    size: "Large (10,000+ employees)",
    globalRating: 4.0,
    website: "https://kiongroup.com",
    foundedYear: 2006,
    tags: ["Material Handling", "Warehouse Technology", "Automation", "Logistics"],
    locations: [
      {
        id: "kion-frankfurt",
        city: "Frankfurt",
        state: "",
        country: "Germany",
        coordinates: [8.6821, 50.1109] as [number, number],
        rating: 4.1,
        salaryRange: { min: 52000, max: 88000 },
        roles: [
          { title: "Automation Engineer", count: 45, salaryRange: { min: 55000, max: 85000 } },
          { title: "Logistics Solutions Manager", count: 35, salaryRange: { min: 58000, max: 88000 } },
          { title: "Mechanical Engineer", count: 40, salaryRange: { min: 52000, max: 80000 } }
        ]
      }
    ]
  },
  {
    id: "59",
    name: "Fresenius",
    industry: "Healthcare",
    description: "German health care group providing products and services for dialysis, hospitals and outpatient medical care.",
    size: "Large (10,000+ employees)",
    globalRating: 3.9,
    website: "https://fresenius.com",
    foundedYear: 1912,
    tags: ["Healthcare", "Medical Devices", "Dialysis", "Hospital Services"],
    locations: [
      {
        id: "fresenius-bad-homburg",
        city: "Bad Homburg",
        state: "",
        country: "Germany",
        coordinates: [8.6181, 50.2269] as [number, number],
        rating: 4.0,
        salaryRange: { min: 55000, max: 95000 },
        roles: [
          { title: "Medical Device Engineer", count: 40, salaryRange: { min: 60000, max: 90000 } },
          { title: "Clinical Research Associate", count: 35, salaryRange: { min: 55000, max: 85000 } },
          { title: "Regulatory Affairs Specialist", count: 25, salaryRange: { min: 58000, max: 95000 } }
        ]
      }
    ]
  },
  {
    id: "60",
    name: "TeamViewer",
    industry: "Software",
    description: "German technology company that provides connectivity software for remote access, control, management, monitoring, and repair of computers and mobile devices.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.2,
    website: "https://teamviewer.com",
    foundedYear: 2005,
    tags: ["Remote Access", "Software", "Connectivity", "Security"],
    locations: [
      {
        id: "teamviewer-goppingen",
        city: "Göppingen",
        state: "",
        country: "Germany",
        coordinates: [9.6518, 48.7014] as [number, number],
        rating: 4.3,
        salaryRange: { min: 58000, max: 100000 },
        roles: [
          { title: "Software Engineer", count: 50, salaryRange: { min: 62000, max: 95000 } },
          { title: "Security Engineer", count: 30, salaryRange: { min: 65000, max: 100000 } },
          { title: "Product Manager", count: 25, salaryRange: { min: 60000, max: 90000 } }
        ]
      }
    ]
  },
  {
    id: "61",
    name: "Slack",
    industry: "Technology",
    description: "Business communication platform offering many IRC-style features for teams and organizations.",
    size: "Medium (1,000-10,000 employees)",
    globalRating: 4.3,
    website: "https://slack.com",
    foundedYear: 2009,
    tags: ["JavaScript", "React", "Node.js", "Electron", "MySQL", "Redis"],
    locations: [
      {
        id: "slack-sf",
        city: "San Francisco",
        state: "CA",
        country: "USA",
        coordinates: [-122.4194, 37.7749] as [number, number],
        rating: 4.4,
        salaryRange: { min: 130000, max: 290000 },
        roles: [
          { title: "Frontend Engineer", count: 20, salaryRange: { min: 140000, max: 270000 } },
          { title: "Backend Engineer", count: 25, salaryRange: { min: 135000, max: 265000 } },
          { title: "Product Manager", count: 12, salaryRange: { min: 150000, max: 290000 } }
        ]
      }
    ]
  }
];

export default generateMockJobData;